/* EL CÁTCHER — chatbot theme-native de Beisbolmania. Sin dependencias, sin servidor.
   v7.0 (7-ago-2026) — pasada "vendedor de verdad" pedida por Karina:
   1) CANDADO DURO DE DEPORTE. El deporte se pregunta en guante/bat/spikes/kit y ya NUNCA
      se pierde al refinar (material, precio, marca, medida, "ver mas", correcciones). Antes
      el filtro de deporte era blando (si quedaban <2 se soltaba el pool entero) y por eso
      "bat compuesto de softbol" devolvia bats de beisbol. Ahora es deporteLock(): filtro
      duro por PRODUCT TYPE ("Bat Softball" vs "Bat Madera/Beisbol/Adulto...") antes de
      cualquier otro filtro; si no queda nada, se busca de nuevo con la query del deporte
      correcto en vez de mostrar el deporte equivocado.
   2) REGLA DE NEGOCIO: en SOFTBOL no hay bats de MADERA (verificado 7-ago contra el
      catalogo: 33 productos "Bat Softball", 100% aluminio o compuesto, cero madera). El
      chip Madera no se ofrece con deporte=softbol y si el cliente la pide se le corrige
      con naturalidad de vendedor y se le ofrece aluminio/compuesto.
   3) 3-4 PRODUCTOS SIEMPRE (MINP=3, MAXP=4) en toda ruta: inicial, precio, marca, rango,
      "otras marcas". Si tras filtrar quedan <3, se amplia avisandolo.
   4) FLUJO DE SPIKES NUEVO: deporte -> suela (metal / plastico / tenis de entrenamiento /
      no se, con explicacion de vendedor) -> TALLA MX obligatoria, y los resultados se
      filtran por VARIANTE DISPONIBLE en esa talla (/products/<handle>.js). Reusa y
      alimenta el perfil de tallas del tema (localStorage bm_tallas_perfil, campo pie_mx).
   5) ESCALERA DE EDAD COMPLETA (Panalitos 3-6 / Infantil 7-11 / Juvenil 12-15 / Adulto,
      + Dama donde existe) en guante, bat, casco, spikes, guanteletas y kit de catcher.
      Nunca se asume adulto en silencio.
   6) ORDEN POR VENTAS REALES (TOPVENTAS, ver el bloque fechado mas abajo) en vez de por
      relevancia del buscador, y chips del menu ordenados por demanda real (sesiones 90d).
   7) LEAD QUE NO SE OLVIDA: se pide DESPUES de dar valor, con tope de 2 peticiones por
      sesion, un reintento en momento natural y jamas si ya lo dio. Guarda la etapa.
   8) BOTON "COMO LLEGAR" a Google Maps cada vez que se habla de la tienda fisica.
   v6.3 (4-ago-2026): CANDADO DE LEAD (regla Karina: "para desbloquearlo tienen que darnos
   sus datos") — al abrir, saludo + formulario obligatorio (nombre + WhatsApp 10 dígitos o
   correo válido); input y chips bloqueados hasta enviarlo; sin botón de saltar. El lead se
   guarda en localStorage SIN expiración: quien ya se registró abre directo para siempre.
   Kill-switch: CANDADO_LEAD abajo, o window.BM_CATCHER_CFG.candadoLead=false desde el
   snippet (A/B en segundos sin re-subir el JS). Validación de contacto con error claro
   sin perder lo tecleado. El envío sigue Klaviyo-primero + /contact best-effort.
   v6.2 (3-ago-2026, tarde): MOTOR SERIALIZADO — cola única de turnos: cada acción del
   cliente (texto o chip) se procesa COMPLETA antes de la siguiente; un mensaje jamás se
   traga, jamás se duplica la respuesta y el orden es siempre cronológico. Burbujas
   vacías bloqueadas en paint(). Saludo instantáneo al abrir (cero vacío blanco) y
   lead-lite a los 900ms vía la misma cola. Chips se desactivan al usarse (anti doble
   clic). Enter en el input siempre envía.
   v6.1 (3-ago-2026): VALIDACIÓN ESTRUCTURAL POR PRODUCT TYPE (listas blancas de tipos
   reales del catálogo por categoría — un accesorio jamás pasa por guante), accesorios de
   guante como categoría propia (cuidar/correas SÍ dan accesorios), deporte filtra fuera
   de cascos, mascota ilustrada de vuelta en launcher y header (con fallback a glifo SVG),
   y type/tags sembrados desde suggest.json (menos fetches).
   v6 (cerebro): WISMO primero (rastrear pedido con 3 rutas + WhatsApp prellenado),
   regla anti-asumir (1 pregunta desambiguadora, máx 3 en total, "no sé" = opción segura),
   flujo de CASCOS completo (deporte + edad, resultados solo cascos por tags),
   máx 3 productos por carrusel con dato técnico visible, escalación anti-loop a WhatsApp,
   chips de siguiente paso tras cada respuesta, persistencia localStorage 24h.
   Conserva TODO el v5: texto libre manda, tags canónicos, correcciones, afinar
   precio/marca, lead Klaviyo-first, log Odoo, cross-sell, FAQ Oaxaca, cero emojis. */
(function(){'use strict';
if(window.__bmCatcher){return}
window.__bmCatcher=true;
var CFG=window.BM_CATCHER_CFG||{};
/* v6.3 REGLA Karina 4-ago: el chat se DESBLOQUEA dando datos. Apagar aquí (false) o con
   BM_CATCHER_CFG.candadoLead=false en el snippet — ideal para A/B o arrepentimiento exprés. */
var CANDADO_LEAD=CFG.candadoLead!==undefined?!!CFG.candadoLead:true;
var WA=CFG.whatsapp||'5219511985033';
var KLAVIYO_CO='WwRXCM',KLAVIYO_LIST='X7RpSw';
var ODOO_LOG='https://karinamatus332-png-beisbolmania-odoo.odoo.com/catcher/log';
var ENVIO_GRATIS=200000; /* centavos: $2,000 */
var MSI_MIN=300000; /* centavos: $3,000 — REGLA Karina 4-ago: MSI a partir de 3 meses, en compras desde $3,000, con tarjeta en el checkout; SIN Mercado Pago y sin prometer 12 meses */
var ENVIO_PESOS=ENVIO_GRATIS/100,MSI_PESOS=MSI_MIN/100;
/* v7.0 Karina 7-ago: cuando se habla de la tienda fisica, ademas del texto va el boton */
var MAPS_URL='https://maps.app.goo.gl/pWXvgpw1cUVaJeYf8';
var TIENDA_DIR='Plaza Santa Lucía, Oaxaca',TIENDA_HOR='lunes a sábado de 10 am a 8 pm';
/* v7.0: minimo 3 y objetivo 4 productos por recomendacion, en TODAS las rutas */
var MINP=3,MAXP=4;
function j(s){try{return JSON.parse(s)}catch(e){return null}}
function lsGet(k){try{return j(localStorage.getItem(k))}catch(e){return null}}
function lsSet(k,v){try{localStorage.setItem(k,JSON.stringify(v))}catch(e){}}
function ssGet(k){try{return j(sessionStorage.getItem(k))}catch(e){return null}}
function ssSet(k,v){try{sessionStorage.setItem(k,JSON.stringify(v))}catch(e){}}
/* v6: la conversación sobrevive al cierre de pestaña (retomar al reabrir) — 24 h de vida */
var TTL=86400000;
function lsGetT(k){var o=lsGet(k);if(!o||!o.exp||o.exp<Date.now()){return null}return o.v}
function lsSetT(k,v){lsSet(k,{v:v,exp:Date.now()+TTL})}
function esc(s){return String(s==null?'':s).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;').replace(/'/g,'&#39;')}
function norm(s){return String(s||'').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g,'')}
function waLink(msg){return 'https://wa.me/'+WA+'?text='+encodeURIComponent(msg)}
function fmt(nu){return Math.round(nu).toString().replace(/\B(?=(\d{3})+(?!\d))/g,',')}
function money(cents){return '$'+fmt(cents/100)}
function priceNum(p){var f=parseFloat(String((p&&p.price)||'').replace(/[^0-9.]/g,''));return isNaN(f)?0:f}
function cap(s){s=String(s||'');return s.charAt(0).toUpperCase()+s.slice(1)}
function median(a){var b=a.filter(function(x){return x>0}).sort(function(x,y){return x-y});if(!b.length){return 0}var m=Math.floor(b.length/2);return b.length%2?b[m]:(b[m-1]+b[m])/2}
/* Glifo SVG monocromo: careta de cátcher (máscara + rejilla), línea 2px — cero emojis */
var SVG_MASK='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 3c-4.4 0-7 2.9-7 7v4c0 4.1 2.6 7 7 7s7-2.9 7-7v-4c0-4.1-2.6-7-7-7Z"/><path d="M5 10.5h14"/><path d="M5.6 15h12.8"/><path d="M12 3v18"/></svg>';
/* v6.1: la MASCOTA ilustrada (Higgsfield) vuelve al launcher y al avatar del header — pedido de Karina 3-ago.
   Si la imagen no carga, el onerror regresa al glifo SVG para nunca dejar el botón vacío. */
var MASCOTA='https://cdn.shopify.com/s/files/1/0267/4940/3235/files/el-catcher-icono.png?v=1783451331';
function mascotaImg(cls){return '<img class="'+cls+'" src="'+MASCOTA+'" alt="" width=116 height=116 onerror="this.style.display=\'none\';this.nextElementSibling.style.display=\'block\'"><span class=bmc-glifo-fb style=display:none>'+SVG_MASK+'</span>'}
/* v7.0 MENU POR DEMANDA REAL. Los chips NO se ordenan a gusto: salen de las sesiones de
   90 dias por landing_page_path (Shopify Analytics, medido 7-ago-2026):
     /collections/calzado-1 1,715 · /collections/cascos 1,481 · /collections/guantes-1 1,290
     /collections/bats 1,183 · /collections/bats-madera 939 · /collections/spikes-infantil 806
     /collections/bats-softbol 770 · /collections/spikes-plastico 729 · /collections/ropa 647
     /collections/spikes-de-metal 603 · /collections/guanteletas 498
   Por eso el arranque es Spikes > Cascos > Guantes y el softbol sube a la pagina 1 (antes
   estaba escondido). OJO: .bmc-chips es scroll horizontal sin wrap — solo se ven ~3 chips
   sin arrastrar, asi que lo mas buscado va PRIMERO. Como regenerar el orden esta en
   equipo_shopify_handoffs.md (pase del 7-ago-2026). */
var MENUS=[
[{l:'Spikes y calzado',f:'spikes'},{l:'Cascos',f:'casco'},{l:'Guantes',f:'guante'},{l:'Ver más',a:'menu1'}],
[{l:'Bats',f:'bat'},{l:'Softbol',f:'softbol'},{l:'Rastrear mi pedido',a:'wismo'},{l:'Ver más',a:'menu2'}],
[{l:'Equipo de catcher',f:'catcherkit'},{l:'Guanteletas',q:'guanteletas',c:'guanteletas'},{l:'Pelotas',q:'pelotas',c:'pelotas'},{l:'Ver más',a:'menu3'}],
[{l:'¿Cuál es mi talla?',a:'talla'},{l:'Nuestra tienda',a:'tienda'},{l:'Hablar con humano',a:'humano'},{l:'Rastrear mi pedido',a:'wismo'}]];
var state=lsGetT('bmcState6')||{inter:0,miss:0,fail:0,qAsked:0,leadAsked:false,await:'',flow:'',perfil:{},leadCtx:'',last:null};
if(!state.perfil){state.perfil={}}
/* v7.0 LEAD: contadores propios (leadAsked del v6 se conserva por compatibilidad) */
if(!('leadPide' in state)){state.leadPide=0}    /* cuantas veces se lo hemos pedido (tope 2) */
if(!('leadValor' in state)){state.leadValor=0}  /* ya le dimos valor (productos o respuesta util) */
if(!('leadEtapa' in state)){state.leadEtapa=''} /* etapa donde se capturo o se pidio */
if(!('leadUlt' in state)){state.leadUlt=0}      /* timestamp de la ultima peticion */
if(!('flow' in state)){state.flow=''}
if(!('last' in state)){state.last=null}
if(!('fail' in state)){state.fail=0}
if(!('qAsked' in state)){state.qAsked=0}
var conv=lsGetT('bmcConv6')||[];
var lead=lsGet('bmcLead');
var root,panel,msgs,input,fab,bubble,open=false,greeted=conv.length>0;
/* Últimos resultados (en memoria; state.last guarda lo mínimo para sobrevivir un reload) */
var lastAll=[],lastQBase='';
/* Sesión persistida para el log a Odoo */
var SES=lsGetT('bmcSes6');
if(!SES){SES=Math.random().toString(36).slice(2)+Date.now().toString(36);lsSetT('bmcSes6',SES)}
var lastLogged=0;
function saveState(){lsSetT('bmcState6',state)}
function saveConv(){lsSetT('bmcConv6',conv.slice(-40))}
function scrollDown(){if(msgs){msgs.scrollTop=msgs.scrollHeight+999}}
/* ---------- v6.2 MOTOR SERIALIZADO ----------
   Un TURNO = el procesamiento completo de una acción del cliente. Solo corre un turno
   a la vez; lo demás espera en turnQ. Un turno termina cuando ya no hay typing (pendT)
   ni red (netPend) en vuelo y hubo 650ms de silencio — con tope duro de 9s. */
var turnQ=[],turnBusy=false,pendT=0,netPend=0,lastAct=0,turnPoll=null,turnCap=0;
function actMark(){lastAct=Date.now()}
function turnIdle(){return pendT===0&&netPend===0&&(Date.now()-lastAct)>=650}
function endTurn(){
if(turnPoll){clearInterval(turnPoll);turnPoll=null}
turnBusy=false;
var next=turnQ.shift();
if(next){runTurn(next)}
}
function runTurn(job){
turnBusy=true;actMark();turnCap=Date.now()+9000;
try{job()}catch(e){}
turnPoll=setInterval(function(){if(turnIdle()||Date.now()>turnCap){endTurn()}},120);
}
function enqueueTurn(job){if(turnBusy){turnQ.push(job)}else{runTurn(job)}}
function tsHora(iso){try{var d=iso?new Date(iso):new Date();var h=d.getHours(),m=d.getMinutes();return (h<10?'0':'')+h+':'+(m<10?'0':'')+m}catch(e){return ''}}
function paint(w,h,c,ts){
/* v6.2: JAMÁS renderizar una burbuja vacía (se veían como errores) */
if(!String(h||'').replace(/<[^>]*>/g,'').trim()&&String(h||'').indexOf('<img')===-1&&(c||'').indexOf('bmc-bare')===-1){return document.createElement('div')}
actMark();
var d=document.createElement('div');d.className='bmc-msg bmc-'+w+(c?' '+c:'');d.innerHTML=h+((c||'').indexOf('bmc-bare')>-1?'':'<span class=bmc-time>'+tsHora(ts)+'</span>');msgs.appendChild(d);scrollDown();return d}
function push(w,h,c){
if(!String(h||'').replace(/<[^>]*>/g,'').trim()&&String(h||'').indexOf('<img')===-1&&(c||'').indexOf('bmc-bare')===-1){return document.createElement('div')}
var ts=new Date().toISOString();conv.push({w:w,h:h,c:c||'',ts:ts});saveConv();return paint(w,h,c,ts)}
function typing(cb){pendT++;actMark();var t=paint('bot','<span class="bmc-dots"><i></i><i></i><i></i></span>','bmc-bare');setTimeout(function(){t.remove();try{cb()}catch(e){}finally{pendT--;actMark()}},400+Math.floor(Math.random()*200))}
function botSay(h,cb){typing(function(){push('bot',h);if(cb){cb()}})}
function chips(pg){var mn=MENUS[pg||0]||MENUS[0];push('bot','<div class=bmc-chips>'+mn.map(function(c,i){return '<button type=button data-m='+(pg||0)+' data-chip='+i+'>'+c.l+'</button>'}).join('')+'</div>','bmc-bare')}
/* v6: SIEMPRE hay chips de siguiente paso tras cada respuesta */
function nextChips(extra){var base=[['menu','Ver el menú'],['humano','Hablar con humano']];var arr=(extra||[]).concat(base).slice(0,4);push('bot','<div class=bmc-chips>'+arr.map(function(c){return '<button type=button data-act="'+esc(c[0])+'">'+esc(c[1])+'</button>'}).join('')+'</div>','bmc-bare')}
function waBtn(msg,label){return '<a class=bmc-wabtn data-leadwa target=_blank rel=noopener href="'+esc(waLink(msg))+'">'+(label||'Seguir por WhatsApp')+'</a>'}
/* v7.0 Karina 7-ago: "cuando ponga a nuestra tienda, que haga un boton para que los dirija
   al Google Maps". Mismo estilo que el boton de WhatsApp (.bmc-wabtn), abre en pestana nueva. */
function mapsBtn(label){return '<a class="bmc-wabtn bmc-maps" target=_blank rel=noopener href="'+esc(MAPS_URL)+'">'+(label||'Cómo llegar')+'</a>'}
/* Texto + boton, para no repetirlo en los 4 lugares donde se menciona la tienda */
function tiendaHtml(pre){return (pre||'Nos encuentras en <b>'+TIENDA_DIR+'</b> — '+TIENDA_HOR+'.')+'<br>'+mapsBtn()+' '+waBtn('Hola, voy a pasar a la tienda de Beisbolmania. ¿Me confirman disponibilidad?','Preguntar antes de ir')}
function leadFormHtml(inicio){return '<form class=bmc-lead><input name=nombre type=text placeholder="Tu nombre" required><input name=contacto type=text placeholder="Tu WhatsApp (10 dígitos) o correo" required><button type=submit>Enviar</button>'+(inicio?'<button type=button class=bmc-skip data-leadskip>Ahora no, gracias</button>':'')+(inicio?'':waBtn('Hola, vengo del chat de beisbolmania.mx y quiero ayuda con mi compra','Prefiero WhatsApp'))+'</form>'}
/* ---------- v6.3 CANDADO DE LEAD ---------- */
function bloqueado(){return CANDADO_LEAD&&!lead}
function candadoFormHtml(){return '<div class="bmc-leadlite bmc-candado-box"><div class=bmc-leadlite-t>Desbloquea el chat</div>Es solo la primera vez: con tu nombre y tu WhatsApp (o correo) te atendemos al instante y hasta te mandamos tu cotización.<form class="bmc-lead bmc-candado"><input name=nombre type=text placeholder="Tu nombre" required><input name=contacto type=text placeholder="Tu WhatsApp (10 dígitos) o correo" required><button type=submit>Abrir el chat</button></form></div>'}
function validaContacto(c){
c=String(c||'').trim();
if(c.indexOf('@')>-1){
if(/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(c)){return {ok:true,v:c}}
return {ok:false,msg:'Ese correo no se ve completo — revísalo (ej. nombre@correo.com).'}}
var d=c.replace(/\D/g,'');
if(d.length===12&&d.slice(0,2)==='52'){d=d.slice(2)}
if(d.length===13&&d.slice(0,3)==='521'){d=d.slice(3)}
if(d.length===10){return {ok:true,v:d}}
return {ok:false,msg:'El WhatsApp va a 10 dígitos (ej. 9511234567) — o si prefieres, déjame tu correo.'}}
function leadError(f,msg){
var e=f.querySelector('.bmc-lead-err');
if(!e){e=document.createElement('div');e.className='bmc-lead-err';var bt=f.querySelector('button[type=submit]');f.insertBefore(e,bt)}
e.textContent=msg}
function lockInput(on){
if(!input){return}
input.disabled=!!on;
var sb=root?root.querySelector('.bmc-inputbar button'):null;
if(sb){sb.disabled=!!on}
input.placeholder=on?'Déjanos tus datos arriba para abrir el chat':'Escribe aquí — ej. guante Rawlings'}
var candadoT=0;
function candadoNudge(){
if(Date.now()-candadoT<3000){return}
candadoT=Date.now();
botSay('Nomás me faltan tus datos del formulario de arriba y arrancamos — es solo la primera vez.')}
/* ---------- v7.0 LEAD QUE NO SE OLVIDA (sin volver al candado) ----------
   Reglas de Karina 7-ago:
   - Se pide DESPUES de dar valor (tras mostrar productos o resolver la duda), nunca al abrir.
   - Si a los ~3 mensajes del cliente no se ha pedido, se pide con copy suave.
   - Si lo salta, UN reintento mas tarde en momento natural (tras agregar al carrito, tras
     preguntar por envio/disponibilidad).
   - MAXIMO 2 peticiones por sesion. Si ya lo dio, JAMAS se vuelve a pedir.
   - El copy vende el intercambio, no pide por pedir.
   - state.leadEtapa guarda en que etapa se capturo (productos / carrito / faq / humano...). */
var LEAD_MAX=2,LEAD_ESPERA=90000; /* 90 s minimo entre la 1a y la 2a peticion */
var LEAD_COPY={
productos:'Oye, para no perderte: déjame tu nombre y tu WhatsApp o correo y <b>te mando la cotización de estos y te aparto el precio</b> mientras lo decides.',
carrito:'Ya que lo tienes en el carrito — dame tu nombre y tu WhatsApp o correo y <b>te aparto el precio y te confirmo existencia</b> antes de que pagues.',
talla:'Déjame tu nombre y tu WhatsApp o correo y <b>te aviso en cuanto entre tu talla</b> — no se te va.',
envio:'Si me dejas tu nombre y tu WhatsApp o correo, <b>te cotizo el envío exacto a tu dirección</b> y te aviso de promos antes que a nadie.',
stock:'Ese producto vuela. Déjame tus datos y <b>te avisamos en cuanto vuelva a caer</b>, o cotízalo directo por WhatsApp.',
ayuda:'¡Va! Te conecto con el equipo. Déjame tu nombre y tu WhatsApp o correo y te contactamos volando, o brinca directo al WhatsApp.',
suave:'Por cierto — déjame tu nombre y tu WhatsApp o correo y <b>el equipo te arma la cotización y te aparta el precio</b>. Promos incluidas.'};
function leadMarcaValor(){if(!state.leadValor){state.leadValor=1;saveState()}}
function leadPuede(){
if(lead){return false}                       /* ya lo dio: jamas se vuelve a pedir */
if(state.leadPide>=LEAD_MAX){return false}   /* tope duro de 2 por sesion */
if(state.leadPide>0&&(Date.now()-(state.leadUlt||0))<LEAD_ESPERA){return false} /* nada de acosar */
return true}
/* Se llama tras dar valor. ctx elige el copy; si no puede, no hace nada (y no se olvida:
   route() reintenta en el siguiente momento natural). */
function leadTrasValor(ctx){
leadMarcaValor();
if(!leadPuede()){return}
askLead(LEAD_COPY[ctx]||LEAD_COPY.suave,ctx||'productos');
}
/* Red de seguridad: si el cliente ya lleva 3+ mensajes y todavia no se lo hemos pedido,
   se pide con copy suave. Aqui es donde antes "se le olvidaba". */
function leadRedDeSeguridad(){
if(!state.leadValor){return}
if(state.inter<3){return}
if(!leadPuede()){return}
askLead(LEAD_COPY.suave,'suave');
}
function maybeLead(ctx){leadTrasValor(ctx||'suave')}
function askLead(txt,etapa){
if(lead){botSay('¡Va! Ya tengo tus datos, el equipo te contacta en breve. Si urge, dale directo al WhatsApp:<br>'+waBtn('Hola, quiero ayuda con mi compra'));return}
state.leadAsked=true;state.leadPide=(state.leadPide||0)+1;state.leadUlt=Date.now();
state.leadCtx=etapa||'ayuda';state.leadEtapa=etapa||'ayuda';saveState();
botSay(txt+leadFormHtml(false))}
/* ---------- PERFIL del cliente (edad, posición, mano, marca, material, presupuesto...) ---------- */
/* v7.0 ESCALERA DE EDAD REAL DEL CATALOGO (Karina 7-ago: "no solamente arrancarle los
   adultos"). Los cortes salen de como estan armadas las colecciones de la tienda:
   Pañalitos 3-6 · Infantil 7-11 · Juvenil 12-15 · Adulto · Dama/Femenil donde existe. */
var PLBL={quien:{nino4:'pañalitos 3-6',nino9:'infantil 7-11',juvenil:'juvenil 12-15',adulto:'adulto',dama:'femenil/dama'},
deporte:{beisbol:'béisbol',softbol:'softbol'},
suela:{metal:'spikes de metal',plastico:'spikes de plástico (molded)',tenis:'tenis de entrenamiento'},
posicion:{infield:'infield',outfield:'outfield',pitcher:'pitcher',catcher:'catcher',primera:'1ª base',nose:'posición por definir'},
mano:{RHT:'lanza con derecha (guante RHT)',LHT:'zurdo (guante LHT)'},
liga:{infantil:'liga infantil',juvenil:'liga juvenil',adulto:'adulto BBCOR/madera',softbol:'softbol',panalitos:'pañalitos (tee ball)'},
material:{aluminio:'bat aluminio',compuesto:'bat compuesto',madera:'bat madera',rec:'material a recomendación'},
terreno:{pasto:'juega en pasto/tierra',turf:'juega en sintético/turf'},
edadKit:{k69:'catcher 6-9 años',k912:'catcher 9-12 años',k1216:'catcher 12-16 años',adulto:'catcher adulto'},
fp:{si:'fastpitch',no:'softbol lento/recreativo'}};
function perfilTexto(){var p=state.perfil,out=[];for(var k in PLBL){if(p[k]&&PLBL[k][p[k]]){out.push(PLBL[k][p[k]])}}
if(p.genero){out.push(p.genero==='nina'?'para niña':'para niño')}
if(p.edad){out.push(p.edad+' años')}
if(p.marca){out.push('marca '+p.marca)}
if(p.exclMarcas&&p.exclMarcas.length){out.push('sin '+p.exclMarcas.join('/'))}
if(p.budget){out.push('presupuesto ~$'+fmt(p.budget))}
if(p.cheap&&!p.budget){out.push('busca económico')}
if(p.drop){out.push('drop '+p.drop)}
if(p.inch){out.push(p.inch+' in')}
if(p.cat){out.push('busca '+p.cat)}
if(p.talla){out.push('talla '+tallaTxt(p.talla))}
return out.join(', ')}
function setP(k,v){state.perfil[k]=v;saveState()}
function segTxt(){var p=state.perfil;
if(p.genero==='nina'){return p.edad?('tu hija de '+p.edad+' años'):'tu niña'}
if(p.genero==='nino'){return p.edad?('tu hijo de '+p.edad+' años'):'tu niño'}
var q=p.quien;if(q==='nino4'){return 'tu peque de 4-8'}if(q==='nino9'){return 'tu niño de 9-13'}if(q==='juvenil'){return 'el juvenil'}return ''}
/* ---------- FLUJO DE VENTA GUIADA (state machine con chips; salta lo ya sabido) ---------- */
var STEPS={
/* v7.0: el DEPORTE es el primer paso de casi todo. Antes solo bat y casco lo preguntaban;
   el flujo de GUANTE no lo preguntaba nunca (Karina pico "Guantes" y solo le dieron edades). */
deporte:{q:'¿Es para <b>béisbol</b> o para <b>softbol</b>?',ops:[['beisbol','Béisbol'],['softbol','Softbol'],['nose','No sé']]},
quien:{q:'¿Para quién es? (así le atino a la talla)',ops:[['nino4','Pañalitos 3-6'],['nino9','Infantil 7-11'],['juvenil','Juvenil 12-15'],['adulto','Adulto'],['nose','No sé la edad']]},
posicion:{q:'¿En qué posición juega?',ops:[['infield','Infield'],['outfield','Outfield'],['pitcher','Pitcher'],['catcher','Catcher'],['primera','Primera base'],['nose','Todavía no sé']]},
mano:{q:'¿Con qué mano <b>LANZA</b>? (el guante va en la otra mano)',ops:[['RHT','Derecha'],['LHT','Zurda']]},
/* v7.0: la escalera de bats sigue las colecciones reales (bats-tee-ball 54, bats-infantiles 83,
   bats-juveniles 80, bats-adulto 48, bats-madera 325, bats-softbol 71). "Softbol" ya NO vive
   aqui: el deporte se pregunta antes y este paso solo reparte por edad/liga. */
liga:{q:'¿Para qué liga o edad es el bat?',ops:[['panalitos','Pañalitos 3-6'],['infantil','Infantil 7-11 (USA/USSSA)'],['juvenil','Juvenil 12-15'],['adulto','Adulto (BBCOR/madera)']]},
/* v7.0: misma escalera pero con el lenguaje del SOFTBOL — nada de "BBCOR/madera", que es
   de beisbol. Los sellos que de verdad traen los bats de softbol del catalogo son
   USSSA/ISA/NSA/USA/WBSC, y la division real es fastpitch vs slowpitch. */
ligaSb:{k:'liga',q:'¿Para qué edad es el bat de softbol?',ops:[['panalitos','Pañalitos 3-6'],['infantil','Infantil 7-11'],['juvenil','Juvenil 12-15'],['adulto','Adulto']]},
material:{q:'¿Qué material prefieres?',ops:[['aluminio','Aluminio'],['compuesto','Compuesto'],['madera','Madera'],['rec','Recomiéndame']]},
/* v7.0 SOFTBOL: mismo paso SIN madera — en softbol no manejamos bats de madera (regla
   Karina 7-ago, confirmada contra el catalogo: los 33 "Bat Softball" son aluminio o compuesto). */
materialSb:{k:'material',q:'¿Qué material prefieres? (en softbol se juega con aluminio o compuesto)',ops:[['aluminio','Aluminio'],['compuesto','Compuesto'],['rec','Recomiéndame']]},
terreno:{q:'¿En qué terreno juegas?',ops:[['pasto','Pasto y tierra'],['turf','Sintético / turf']]},
/* v7.0 SPIKES (rediseño pedido por Karina: "hay que decirle mejor: ¿ocupas de metal o de
   plástico?, y pedirle su talla y mandarle opciones DE SU TALLA").
   Colecciones reales verificadas 7-ago: spikes-de-metal 42 · spikes-plastico 167 ·
   spikes-infantil 68 · entrenamiento-1 (tenis) 37 · mujer 11. */
suela:{q:'¿Los ocupas de <b>METAL</b> o de <b>PLÁSTICO</b>?',ops:[['metal','Metal'],['plastico','Plástico'],['tenis','Tenis de entrenamiento'],['nose','No sé cuál me toca']]},
quienSp:{k:'quien',q:'¿Para quién son?',ops:[['nino4','Pañalitos 3-6'],['nino9','Infantil 7-11'],['juvenil','Juvenil 12-15'],['adulto','Adulto'],['dama','Dama']]},
/* k:'talla' es OBLIGATORIO — el valor se guarda en perfil.talla, y sin esta k el paso
   nunca se daba por resuelto y volvia a preguntar la talla en bucle. */
tallaPie:{k:'talla',q:'¿Qué número calzas? (talla MX)',ops:[]}, /* chips dinamicos: ver askTallaPie() */
edadKit:{q:'¿Qué edad tiene el catcher? (los kits van por edad)',ops:[['k69','6-9 años'],['k912','9-12 años'],['k1216','12-16 años'],['adulto','Adulto']]},
fp:{q:'¿Juegan <b>fastpitch</b> (bola rápida)?',ops:[['si','Sí, fastpitch'],['no','No, lento/recreativo']]},
catSb:{k:'cat',q:'¿Qué buscas para softbol?',ops:[['guante','Guante'],['bat','Bat'],['spikes','Spikes'],['casco','Casco'],['kit','Equipo de catcher'],['pelotas','Pelotas']]},
depCasco:{k:'deporte',q:'¿El casco es para <b>béisbol</b> o para <b>softbol</b>?',ops:[['beisbol','Béisbol'],['softbol','Softbol'],['nose','No sé']]},
/* v7.0: la escalera completa (casco-panalitos 19 · casco-infantil 85 · casco-adulto 42 ·
   cascos-softbol 31). Ya no arranca en Adulto: lo mas pedido es infantil. */
edadCasco:{k:'quien',q:'¿Para quién es el casco?',ops:[['nino4','Pañalitos 3-6'],['nino9','Infantil 7-11'],['juvenil','Juvenil 12-15'],['adulto','Adulto'],['nose','No sé la edad']]}};
/* "No sé" (chip o tecleado) = opción segura + guía; NUNCA otra pregunta */
var SAFE={deporte:{v:'beisbol',msg:'Sin bronca — te muestro lo de <b>béisbol</b>, que es lo que más sale; si resulta softbol me dices "es de softbol" y lo cambio al instante.'},
depCasco:{v:'beisbol',msg:'Sin bronca — la mayoría de nuestros clientes lo usa para <b>béisbol</b>, te muestro esos (si resulta softbol, me dices y corregimos).'},
quien:{v:'adulto',msg:'Va — arranco con talla <b>adulto</b>. Si es para un peque, nada más dime su edad ("tiene 9 años") y te lo cambio a su talla exacta.'},
edadCasco:{v:'adulto',msg:'Va — arranco con talla <b>adulto</b>. Si es para un peque, dime su edad ("tiene 9 años") y te lo cambio a pañalitos, infantil o juvenil.'},
posicion:{v:'nose',msg:'No pasa nada — te muestro guantes versátiles que sirven en casi cualquier posición.'},
mano:{v:'RHT',msg:'La mayoría lanza con la derecha, así que te muestro los estándar (RHT); si es zurdo me dices y lo cambio.'},
liga:{v:'adulto',msg:'Te muestro los de <b>adulto (BBCOR/madera)</b>, que es lo más común; si es para liga infantil o juvenil dime la edad.'},
ligaSb:{v:'adulto',msg:'Te muestro los de <b>adulto</b>, que es lo más común; si es para una jugadora más chica dime su edad y ajusto.'},
material:{v:'rec',msg:'Yo te recomiendo: para empezar, el <b>aluminio</b> es el más noble — listo desde el primer swing.'},
materialSb:{v:'rec',msg:'Yo te recomiendo: en softbol el <b>aluminio</b> es el más noble y viene listo desde el primer swing; el compuesto es para cuando ya buscas más potencia.'},
terreno:{v:'pasto',msg:'La mayoría juega en pasto y tierra — te muestro esos.'},
/* v7.0 SPIKES: "no sé" NO se salta con un default — el vendedor explica y vuelve a preguntar
   (se maneja aparte, en suelaNoSe(); esta entrada es el respaldo si algo se sale del carril). */
suela:{v:'plastico',msg:'Te muestro los de <b>plástico (molded)</b>, que son los que sirven en casi cualquier liga.'},
quienSp:{v:'adulto',msg:'Va — arranco con adulto. Si son para un peque dime su edad y te los cambio a su talla.'},
edadKit:{v:'adulto',msg:'Te muestro los de adulto; si es para un peque dime su edad y ajusto.'},
fp:{v:'no',msg:'Te muestro los de softbol recreativo, que es lo más común.'},
catSb:{v:'guante',msg:'Arranco por el guante, que es lo que más se busca en softbol.'}};
/* v7.0: el DEPORTE encabeza guante, bat, spikes y kit (antes guante no lo preguntaba jamas).
   El tope de 3 preguntas del v6 se respeta: el deporte cuenta como una de ellas, y todo lo
   que el cliente ya dijo por texto se salta solo. */
var FLOWS={
guante:{steps:['deporte','quien','posicion','mano'],done:recGuante,hi:'Buena elección. Para darte el guante exacto te hago unas preguntas rápidas de vendedor.'},
bat:{steps:['deporte','liga','material'],done:recBat,hi:'Vamos por ese bat. Unas preguntas para no fallarle.'},
spikes:{steps:['deporte','suela','tallaPie'],done:recSpikes,hi:'Spikes nuevos, va. Tres cosas y te doy los correctos <b>en tu número</b>.'},
catcherkit:{steps:['deporte','edadKit'],done:recKit,hi:'El corazón del equipo. Los kits de catcher van por deporte y por edad, así que dime:'},
casco:{steps:['depCasco','edadCasco'],done:recCasco,hi:'Buen ojo — el casco correcto va por deporte y por talla, así que dime:'},
softbol:{steps:['catSb','fp','quien'],done:recSoftbol,hi:'Puro softbol. Déjame afinar la recomendación.'}};
var FCAT={guante:'guante',bat:'bat',spikes:'spikes',catcherkit:'kit',casco:'casco'};
/* v7.0 SOFTBOL SIN MADERA: cuando el flujo de bat ya sabe que es softbol, el paso de material
   se cambia por materialSb (mismos chips, SIN Madera). Se resuelve al vuelo en pendingStep. */
function stepSwap(sid){
if(state.perfil.deporte==='softbol'){
if(sid==='material'){return 'materialSb'} /* sin Madera */
if(sid==='liga'){return 'ligaSb'}         /* sin "BBCOR/madera" */
}
return sid}
function stepKey(sid){return (STEPS[sid]&&STEPS[sid].k)||sid}
function chipsHtml(sid,ops){return '<div class=bmc-chips>'+ops.map(function(o){return '<button type=button data-fk="'+esc(sid)+'" data-fv="'+esc(o[0])+'">'+o[1]+'</button>'}).join('')+'</div>'}
function askStep(sid){
sid=stepSwap(sid);
if(sid==='tallaPie'){askTallaPie();return}
state.qAsked++;saveState();var s=STEPS[sid];
botSay(s.q,function(){push('bot',chipsHtml(sid,s.ops),'bmc-bare')})}
function pendingStep(){var f=FLOWS[state.flow];if(!f){return null}for(var i=0;i<f.steps.length;i++){var sid=stepSwap(f.steps[i]);if(!state.perfil[stepKey(sid)]){return f.steps[i]}}return null}
function nextStep(){
var f=FLOWS[state.flow];
if(!f){return}
/* mandamiento: MÁXIMO 3 preguntas por conversación de venta — después, a recomendar.
   v7.0: en SPIKES el tope sube a 4 porque la TALLA es obligatoria (sin ella no podemos
   prometer que lo que mostramos existe en su numero, que es justo lo que pidio Karina). */
var tope=(state.flow==='spikes')?4:3;
if(state.qAsked<tope){var sid=pendingStep();if(sid){askStep(sid);return}}
var done=f.done;state.flow='';saveState();done();
}
function startFlow(name,intro){
if(!FLOWS[name]){return}
/* v6.2 dedupe: si YA estamos en este flujo con pregunta pendiente, re-preguntar sin repetir el intro */
if(state.flow===name&&pendingStep()){state.miss=0;saveState();nextStep();return}
state.flow=name;state.miss=0;state.fail=0;state.qAsked=0;saveState();
if(FCAT[name]){setP('cat',FCAT[name])}
/* v7.0: pidio madera PARA SOFTBOL desde el primer mensaje ("bat de softbol de madera").
   No se le borra el dato en silencio: se le explica y se le ofrecen los materiales reales. */
if(name==='bat'&&state.perfil.deporte==='softbol'&&state.perfil.material==='madera'){maderaEnSoftbol();return}
var f=FLOWS[name];
/* v6: si el texto ya trajo todos los datos, cero preguntas — directo a recomendar */
if(!pendingStep()){state.flow='';saveState();f.done();return}
var hi=intro||f.hi;
var known=f.steps.filter(function(s){return state.perfil[stepKey(s)]}).map(function(s){var k=stepKey(s);return PLBL[k]&&PLBL[k][state.perfil[k]]}).filter(Boolean);
if(known.length){hi+='<br><small>Ya me sé esto de ti: <b>'+esc(known.join(', '))+'</b> — solo te pregunto lo que falta.</small>'}
botSay(hi,nextStep);
}
function pickFlowChip(sid,v,label){
push('user',esc(String(label||'').trim()));state.inter++;
enqueueTurn(function(){
/* v7.0 SPIKES: "no sé cuál me toca" NO se resuelve con un default silencioso — el vendedor
   explica la diferencia real y vuelve a preguntar (pedido literal de Karina). */
if(sid==='suela'&&v==='nose'){suelaNoSe();return}
if(sid==='tallaPie'){tomaTalla(v);return}
if(v==='nose'&&SAFE[sid]){var sf=SAFE[sid];setP(stepKey(sid),sf.v);botSay(sf.msg,nextStep);return}
setP(stepKey(sid),v);
/* v7.0: al fijar softbol, un "madera" heredado deja de tener sentido (no existe) */
if(stepKey(sid)==='deporte'&&v==='softbol'&&state.perfil.material==='madera'){delete state.perfil.material;saveState()}
nextStep();
});
}
/* ---------- v7.0 SPIKES: suela y TALLA ---------- */
/* Etiqueta corta para meterla dentro de una frase ("busco spikes de metal en talla ...").
   PLBL.suela trae la etiqueta larga y al prefijarla salia "spikes de spikes de metal". */
var SUELA_CORTA={metal:'spikes de metal',plastico:'spikes de plástico',tenis:'tenis de entrenamiento'};
var suelaVueltas=0;
function suelaNoSe(){
suelaVueltas++;
var exp='Va, te lo explico como se lo explico en el mostrador:<br>'
+'<b>Metal</b> — es lo de ligas mayores y adulto: se clava mejor en tierra y no resbalas. Ojo: en <b>muchas ligas infantiles está prohibido</b>.<br>'
+'<b>Plástico (molded)</b> — la suela de tacos de plástico. Es la de infantil y la de toda liga que no permite metal; sirve en pasto y en tierra.<br>'
+'<b>Tenis de entrenamiento</b> — suela lisa de goma, para práctica, gimnasio y campo sintético (turf).';
if(suelaVueltas>=2){
/* si ya se lo explicamos y sigue sin decidir, no lo dejamos dando vueltas */
setP('suela','plastico');
botSay(exp+'<br>Si me lo permites: para no fallarle, el <b>plástico</b> te sirve en cualquier cancha y en cualquier liga. Arranco por ahí y si tu liga sí permite metal me dices.',nextStep);
return}
botSay(exp,function(){push('bot',chipsHtml('suela',STEPS.suela.ops),'bmc-bare')})}
/* Perfil de tallas del tema (snippets/bm-tallas-veredicto.liquid, Tallas 2.0 del 5-ago).
   Claves: bm_tallas_perfil (invitado) y bm_tallas_perfil_<customer.id> (con sesion, el id
   sale de data-bm-cliente del body). Campos: cabeza_cm, pie_mx, edad, altura_cm, act.
   El Catcher LEE de ahi para no volver a preguntar, y ESCRIBE ahi lo que le dicten para
   que la ficha de producto lo aproveche. Merge, nunca reemplazo: no le borramos medidas. */
function tallaClienteId(){try{return (document.body&&document.body.getAttribute('data-bm-cliente'))||''}catch(e){return ''}}
function tallaClave(){var id=tallaClienteId();return id?'bm_tallas_perfil_'+id:'bm_tallas_perfil'}
function tallaPerfilGet(){
try{
var c=localStorage.getItem(tallaClave());
if(c===null&&tallaClienteId()){c=localStorage.getItem('bm_tallas_perfil')}
var p=j(c||'{}');return (p&&typeof p==='object')?p:{};
}catch(e){return {}}}
function tallaPerfilSetPie(v){
try{
var p=tallaPerfilGet();
p.pie_mx=v;p.act=new Date().toISOString().slice(0,10);
localStorage.setItem(tallaClave(),JSON.stringify(p));
}catch(e){}}
/* Normaliza "#26", "26.5", "27 MX", "del 26", "26 mexicana", "9 US" -> numero MX */
function normTalla(t){
var s=norm(t).replace(/[#"]/g,' ').replace(/,/g,'.');
var us=s.match(/(\d{1,2}(?:\.\d)?)\s*(us|americana|gringa)/);
if(us){var u=parseFloat(us[1]);if(u>=1&&u<=16){return Math.round((u+18)*2)/2}} /* US hombre -> MX (US+18) */
var m=s.match(/(\d{1,2}(?:\.\d)?)/);
if(!m){return 0}
var v=parseFloat(m[1]);
if(v>=15&&v<=34){return Math.round(v*2)/2}
return 0}
function tallaTxt(v){return '#'+(v%1?v.toFixed(1):v)+' MX'}
/* Chips de talla por segmento, con los rangos que de verdad existen en el catalogo de calzado */
function tallasChips(){
var q=state.perfil.quien;
if(q==='nino4'){return [15,16,17,18,19,20]}
if(q==='nino9'){return [20,21,22,23,24]}
if(q==='juvenil'){return [23,24,25,26,27]}
if(q==='dama'){return [22,23,24,25,26]}
return [25,26,27,28,29,30]}
function askTallaPie(){
var pf=tallaPerfilGet();
/* REUSO: si el tema ya guardo su talla de pie, NO se la volvemos a preguntar — se confirma. */
if(pf&&pf.pie_mx&&!state.perfil.tallaConfirm){
state.qAsked++;state.perfil.tallaConfirm=1;saveState();
botSay('Ya tengo guardada tu talla de pie: <b>'+tallaTxt(pf.pie_mx)+'</b>. ¿Seguimos con esa?',function(){
push('bot',chipsHtml('tallaPie',[[String(pf.pie_mx),'Sí, '+tallaTxt(pf.pie_mx)],['otra','Es otra talla']]),'bmc-bare')});
return}
state.qAsked++;saveState();
var ops=tallasChips().map(function(n){return [String(n),tallaTxt(n)]});
botSay('¿Qué número calzas? (talla <b>MX</b> — si la sabes en US me la dices y la convierto)',function(){
push('bot',chipsHtml('tallaPie',ops),'bmc-bare');
push('bot','<small>Si tu número no está ahí, escríbelo tal cual (ej. 26.5).</small>','bmc-bare')})}
function tomaTalla(v){
if(v==='otra'){state.perfil.tallaConfirm=0;saveState();botSay('Va — dime tu número en MX (ej. 26.5) y te muestro solo lo que sí tengo en esa talla.',function(){state.await='talla';saveState()});return}
var n=normTalla(v);
if(!n){botSay('No le atiné a ese número. Dímelo así: 26, 26.5 o "#27".',function(){state.await='talla';saveState()});return}
setP('talla',n);
tallaPerfilSetPie(n); /* queda guardada para la ficha de producto */
nextStep()}
/* "no sé" tecleado a media pregunta: opción segura + guía, jamás otra pregunta */
function flowNoSe(){
var sid=pendingStep();
if(!sid){nextStep();return true}
var sf=SAFE[sid]||SAFE[stepKey(sid)];
if(!sf){nextStep();return true}
setP(stepKey(sid),sf.v);
botSay(sf.msg,nextStep);
return true}
/* ---------- Recomendaciones expertas por categoría ---------- */
function recGuante(){
var p=state.perfil,q,why;
var seg=segTxt();
if(p.posicion==='catcher'){q='guante catcher';why='Para catcher va <b>mascota (manopla) cerrada y acolchada</b> — un guante normal no aguanta la recta.'}
else if(p.posicion==='primera'){q='guante primera base';why='Para 1ª base va <b>manopla larga de primera</b>: más alcance en las recibidas y los tiros bajos.'}
else if(p.quien==='nino4'){q='guante infantil';why='Para '+(seg||'niños de 4-8')+' va un <b>guante infantil de 9.5-10.5"</b>: ligero y fácil de cerrar para su manita.'}
else if(p.quien==='nino9'){q='guante juvenil';why='Para '+(seg||'niños de 9-13')+' el punto dulce es un <b>guante juvenil de 11-11.5"</b>: controla la bola sin pesarle.'}
else if(p.posicion==='outfield'){q='guante 12.75';why='Para outfield se usa <b>guante largo de 12.5-12.75"</b>: más alcance para los elevados.'}
else if(p.posicion==='infield'){q='guante 11.5';why='Para infield se usa <b>guante corto de 11.25-11.75"</b>: sacas la bola rápido para el tiro.'}
else if(p.posicion==='pitcher'){q='guante 12';why='Para pitcher va un <b>guante de 11.75-12" con red cerrada</b>: esconde el grip de la bola.'}
else{q='guante beisbol';why='Te muestro guantes versátiles de <b>11.5-12"</b>: sirven para casi cualquier posición mientras defines la tuya.'}
if(p.deporte==='softbol'&&q.indexOf('softbol')===-1){
/* v7.0: en softbol el guante tambien cambia por posicion — hay mascotas de softbol catcher
   (coleccion guante-softbol-catcher, 28 productos) y guantes de softbol de 11 a 14 in. */
if(p.posicion==='catcher'){q='guante catcher softbol';why='Para catcher de <b>softbol</b> va mascota de fastpitch (32-34"): la bola es de 12" y pide más bolsa.'}
else if(p.posicion==='primera'){q='guante primera base softbol';why='Para 1ª base en <b>softbol</b> va manopla larga: más alcance para la bola grande.'}
else{q='guante softbol';why='Para <b>softbol</b> el guante va más grande (la bola es de 12") — te muestro los indicados.'}
if(p.fp==='si'){q='guante fastpitch';why+='<br>Y como es <b>fastpitch</b>, te muestro los de bolsa profunda, que es lo que se usa en bola rápida.'}
}
if(p.mano==='LHT'){why+='<br>Como <b>lanza con la zurda</b>, el guante va en la mano derecha: en la ficha busca la versión <b>LHT</b> (Left Hand Throw).'}
else if(p.mano==='RHT'){why+='<br>Como lanza con la derecha, el guante va en la mano izquierda (<b>RHT</b>, la versión estándar).'}
searchProducts(buildQuery(q),why+'<br>Esto fue lo que atrapé para ti:');
}
function recBat(){
var p=state.perfil,q,why;
var sb=(p.deporte==='softbol'||p.liga==='softbol');
if(sb){setP('deporte','softbol');
/* v7.0 REGLA KARINA: en softbol NO hay bats de madera. Si venía "madera" en el perfil
   (tecleada o heredada de un bat de béisbol), se limpia ANTES de armar la query. */
if(p.material==='madera'){delete state.perfil.material;saveState()}
q='bat softbol';why='Bat de <b>softbol</b>: barril y drop pensados para bola de 12" — no es lo mismo que uno de béisbol.';
if(p.fp==='si'){q='bat softbol fastpitch';why+='<br>Y de <b>fastpitch</b>, que es lo que pide la bola rápida (un slowpitch no te sirve ahí).'}
}
else if(p.liga==='panalitos'){q='bat panalitos';why='Para <b>pañalitos (3-6 años)</b> va bat de tee ball: barril 2 1/4 y lo más ligero que hay, para que lo pueda mover.'}
else if(p.liga==='infantil'){q='bat infantil';why='Para <b>infantil (7-11)</b> busca <b>drop -10 u -11</b> (bat ligero): a esa edad gana la velocidad del swing, no el peso.'}
else if(p.liga==='juvenil'){q='bat juvenil';why='Para <b>juvenil (12-15)</b> el drop baja a <b>-8 o -5</b>: ya aguanta más peso y lo prepara para el brinco al -3.'}
else{q='bat bbcor';why='Para adulto va <b>BBCOR (drop -3)</b> o madera: es lo que exigen las ligas mayores y federadas.'}
var mat=state.perfil.material;
if(mat==='madera'&&!sb){q='bat madera';why+='<br>En <b>madera</b> el punto dulce es más chico pero el contacto se siente de lujo (y en varias ligas es obligada).'}
else if(mat==='aluminio'){q+=' aluminio';why+='<br>El <b>aluminio</b> viene listo desde el primer swing y aguanta el uso rudo.'}
else if(mat==='compuesto'){q+=' compuesto';why+='<br>El <b>compuesto</b> da punto dulce más grande y menos vibración (pide ~150 swings de break-in).'}
searchProducts(q,why+'<br>Mira estos bats:');
}
/* v7.0 SPIKES rediseñado: suela + talla, y los resultados se filtran por VARIANTE disponible
   en su numero (ver filtraPorTalla). Colecciones/consultas alineadas al catalogo real. */
function recSpikes(){
var p=state.perfil,q,why;
var nino=(p.quien==='nino4'||p.quien==='nino9'||p.genero==='nina'||p.genero==='nino');
var juv=(p.quien==='juvenil');
setP('cat','spikes');
if(p.suela==='tenis'){q='tenis de entrenamiento';why='<b>Tenis de entrenamiento</b>: suela lisa de goma para práctica, gimnasio y campo sintético — no maltratan el turf.'}
else if(p.suela==='metal'){q=nino?'spikes metal infantil':'spikes metal';why='<b>Spikes de metal</b>: se clavan en la tierra y no resbalas corriendo las bases. Es lo de adulto y ligas mayores.'}
else{q=nino?'spikes plastico infantil':'spikes plastico';why='<b>Spikes de plástico (molded)</b>: agarran en pasto y tierra y te los aceptan en cualquier liga — por eso son los que más vendemos.'}
if(p.suela==='metal'&&nino){why+='<br>Ojo de vendedor: en <b>ligas infantiles casi siempre prohíben el metal</b>. Si tu liga no lo permite, dime "de plástico" y te los cambio.'}
if(p.deporte==='softbol'){why+='<br>Sirven igual para <b>softbol</b>: el calzado no cambia entre béisbol y softbol, lo que cambia es la suela y tu número.'}
if(p.quien==='dama'){q+=' mujer';why+='<br>Y en horma de <b>dama</b>.'}
else if(juv&&!nino){q+=' juvenil'}
if(p.talla){why+='<br>Y lo importante: <b>solo te muestro los que sí tengo en tu '+tallaTxt(p.talla)+'</b>.'}
searchProducts(q,why+'<br>Estos son los indicados:');
}
function recKit(){
var p=state.perfil;
var edad=PLBL.edadKit[p.edadKit]||'';
var sb=p.deporte==='softbol';
var q=sb?'equipo catcher softbol':'equipo catcher beisbol';
var why='Los kits de catcher van <b>por edad</b> (careta, peto y espinilleras a la medida). Para <b>'+esc(edad.replace('catcher ',''))+'</b> revisa en la ficha que marque ese rango.';
if(sb){why+='<br>Y de <b>softbol</b>: los femeniles traen peto y careta con el corte de softbol (no es el mismo que el de béisbol).'}
searchProducts(q,why+'<br>Protección completa:');
}
function recCasco(){
var p=state.perfil,q='casco',why;
setP('cat','casco');
if(p.deporte==='softbol'){q='casco softbol';why='Para <b>softbol</b> el casco correcto trae careta (en la mayoría de las ligas es obligatoria).'}
else{why='Para <b>béisbol</b> va casco de bateo con doble orejera — protege ambos lados sin importar el lado del plato.'}
var edad='';
if(p.quien==='adulto'){edad='adulto'}else if(p.quien==='juvenil'){edad='juvenil'}
else if(p.quien==='nino9'){edad='infantil'}else if(p.quien==='nino4'){edad='pañalitos'}
if(edad){why+='<br>Y en talla <b>'+edad+'</b>: el casco debe quedar firme, sin bailar ni apretar.'}
searchProducts(q,why+'<br>Estos son los cascos que traigo para ti:');
}
function recSoftbol(){
var p=state.perfil,cat=p.cat||'guante',q,why;
var fp=p.fp==='si';
setP('deporte','softbol');
if(cat==='bat'){
/* v7.0: en softbol NO hay bats de madera — si venia en el perfil, fuera */
if(p.material==='madera'){delete state.perfil.material;saveState()}
q=fp?'bat softbol fastpitch':'bat softbol slowpitch';
why=fp?'Para <b>fastpitch</b> el bat debe ser específico de fastpitch (barril 2 1/4 y drop para bola rápida de 12") — no sirve uno de slowpitch.':'Para softbol lento va <b>bat de slowpitch</b>: más barril para la bola grande.';
why+='<br>Y algo que siempre aclaro: <b>en softbol no hay bats de madera</b> — se juega con aluminio o compuesto.'}
else if(cat==='pelotas'){q='pelotas softbol';why='Pelotas oficiales de <b>softbol de 12"</b>, las que piden en liga.'}
else if(cat==='guante'){q=fp?'guante softbol fastpitch':'guante softbol';why=fp?'Para <b>fastpitch</b> el guante va más grande (12-13", la bola es de 12") y con bolsa profunda.':'Para softbol recreativo va <b>guante de 12.5-14"</b>: más bolsa para la bola grande.'}
else if(cat==='casco'){setP('cat','casco');q='casco softbol';why='Casco de <b>softbol</b>: en la mayoría de las ligas femeniles la careta es obligatoria, así que te muestro los que la traen o la aceptan.'}
else if(cat==='kit'){q='equipo catcher softbol';why='Equipo de catcher de <b>softbol</b> (femenil): peto y careta con el corte de softbol, no el de béisbol.'}
else if(cat==='spikes'){setP('cat','spikes');q='spikes softbol';why='En calzado no cambia el deporte — lo que manda es la suela y tu número. Te muestro los de softbol.'}
else{q=cat+' softbol';why='Va lo de '+esc(cat)+' para softbol.'}
if(p.quien==='nino4'||p.quien==='nino9'||p.quien==='juvenil'){why+='<br>Y en talla '+(PLBL.quien[p.quien]||'de su edad')+', para que le quede bien.'}
searchProducts(buildQuery(q),why+'<br>Puro softbol:');
}
/* ---------- PARSER: marca, presupuesto, deporte, material, edad, mano, categoría ---------- */
var BRANDS=[['rawlings',/rawlings?/],['wilson',/wilson/],['easton',/easton/],['marucci',/marucci/],['mizuno',/mizuno/],['victus',/victus/],['louisville',/louisville|slugger/],['demarini',/de ?marini/],['franklin',/franklin/],['champro',/champro/],['evoshield',/evoshield/],['all star',/all[ -]?star/],['new balance',/new ?balance|(^|\s)nb(\s|$)/],['under armour',/under ?armou?r|(^|\s)ua(\s|$)/],['jordan',/jordan/],['nike',/(^|\s)nike(\s|$)/],['adidas',/adidas/]];
function brandRe(m){if(!m){return null}for(var i=0;i<BRANDS.length;i++){if(BRANDS[i][0]===m){return BRANDS[i][1]}}return null}
function brandsIn(items){var out=[];items.forEach(function(p){var t=norm(p.title);for(var i=0;i<BRANDS.length;i++){if(BRANDS[i][1].test(t)&&out.indexOf(BRANDS[i][0])<0){out.push(BRANDS[i][0])}}});return out.slice(0,6)}
function brandHit(title,names){var t=norm(title);for(var i=0;i<(names||[]).length;i++){var re=brandRe(names[i]);if(re&&re.test(t)){return true}}return false}
function sniffCompra(n){
for(var i=0;i<BRANDS.length;i++){if(BRANDS[i][1].test(n)){setP('marca',BRANDS[i][0]);break}}
if(/(barat|econom)/.test(n)){setP('cheap',1)}
if(/(mader|maple|bamb|birch|abedul)/.test(n)){setP('material','madera')}
else if(/(aluminio|alloy)/.test(n)){setP('material','aluminio')}
else if(/(compuesto|composite)/.test(n)){setP('material','compuesto')}
/* v7.0: el deporte se fija aqui y ya NO se toca al refinar (candado duro en deporteLock) */
if(/(softbol|softball|fastpitch|slowpitch|slow pitch|fast pitch)/.test(n)){setP('deporte','softbol')}
else if(/(beisbol|baseball)/.test(n)){setP('deporte','beisbol')}
if(/(slowpitch|slow pitch|lento)/.test(n)){setP('fp','no')}
/* v7.0 SPIKES: la suela y la talla tambien se leen del texto libre */
if(/(de metal|metalicos|metálicos|con metal|tacos? de metal)/.test(n)){setP('suela','metal')}
else if(/(de plastico|plastico|molded|tpu|goma)/.test(n)){setP('suela','plastico')}
else if(/(tenis de entrenamiento|entrenamiento|turf|sinteti)/.test(n)&&/(spike|tenis|calzado|tacho)/.test(n)){setP('suela','tenis')}
var tz=n.match(/(?:talla|numero|calzo|del|#)\s*#?\s*(\d{1,2}(?:[.,]\d)?)\s*(mx|mexicana|us|americana)?/);
if(tz){var tv=normTalla(tz[0]);if(tv){setP('talla',tv);tallaPerfilSetPie(tv)}}
var m=n.match(/drop\s*[- ]?\s*(\d{1,2})/);
if(m){setP('drop','-'+m[1])}
m=n.match(/(\d{1,2}(?:\.\d{1,2})?)\s*(?:pulgadas|pulg\b|inches|inch|in\b|")/);
if(m){var iv=parseFloat(m[1]);if(iv>=8&&iv<=36){setP('inch',m[1])}}
var b=0;m=n.match(/(menos de|maximo|max|hasta|no mas de|que no pase de)\s*\$?\s*(\d[\d,]{2,})/);
if(m){b=parseInt(m[2].replace(/\D/g,''),10)}
if(!b){m=n.match(/(como|unos|alrededor de|aprox\w*|cerca de)\s*\$?\s*(\d[\d,]{2,})\s*(pesos|mxn|varos|baros)?/);if(m){b=Math.round(parseInt(m[2].replace(/\D/g,''),10)*1.15)}}
if(!b){m=n.match(/\$\s*(\d[\d,]{2,})/);if(m){b=parseInt(m[1].replace(/\D/g,''),10)}}
if(!b){m=n.match(/(\d[\d,]{2,})\s*(pesos|mxn|varos|baros)/);if(m){b=parseInt(m[1].replace(/\D/g,''),10)}}
if(b>=200&&b<=100000){setP('budget',b)}
}
function sniffPerfil(n){
var m=n.match(/(\d{1,2})\s*an(o|i)/); /* "8 años" ya normalizado sin acento */
if(!m){m=n.match(/tiene\s+(\d{1,2})(\s|$)/)}
if(!m){var m2=n.match(/(hij[oa]|nin[oa]|nen[ea]|sobrin[oa]|niet[oa]|peque)\s+de\s+(\d{1,2})(?!\d)/);if(m2){m=[m2[0],m2[2]]}}
if(m){var e=parseInt(m[1],10);
if(e>=3&&e<=70){
setP('edad',e);
/* v7.0: escalera alineada a las colecciones reales — Pañalitos 3-6, Infantil 7-11,
   Juvenil 12-15, Adulto 16+ */
if(e<=6){setP('quien','nino4');setP('edadKit','k69')}
else if(e<=11){setP('quien','nino9');setP('edadKit',e<=9?'k69':'k912')}
else if(e<=15){setP('quien','juvenil');setP('edadKit',e<=12?'k912':'k1216')}
else{setP('quien','adulto');setP('edadKit','adulto')}
if(!state.perfil.liga){setP('liga',e<=6?'panalitos':(e<=11?'infantil':(e<=15?'juvenil':'adulto')))}
}}
if(/(hija|nena|nieta|sobrina)s?([^a-z]|$)/.test(n)||/(^|\s)ninas?([^a-z]|$)/.test(n)){setP('genero','nina')}
else if(/(hijo|nene|nieto|sobrino)s?([^a-z]|$)/.test(n)||/(^|\s)ninos?([^a-z]|$)/.test(n)){setP('genero','nino')}
if(/infantil/.test(n)&&!state.perfil.quien){setP('quien','nino9');if(!state.perfil.liga){setP('liga','infantil')}}
if(/juvenil/.test(n)){setP('quien','juvenil');if(!state.perfil.liga){setP('liga','juvenil')}}
if(/(^|\s)adult[oa]s?([^a-z]|$)/.test(n)){setP('quien','adulto');if(!state.perfil.liga){setP('liga','adulto')}}
if(state.perfil.genero&&!state.perfil.quien){setP('quien','nino9')}
if(/zurd/.test(n)){setP('mano','LHT')}
if(/diestr/.test(n)){setP('mano','RHT')}
if(/derech/.test(n)&&/(lanza|tira|avienta|mano)/.test(n)){setP('mano','RHT')}
if(/(infield|cuadro|shortstop|short stop|parador en corto|segunda base|tercera base)/.test(n)){setP('posicion','infield')}
if(/(outfield|jardinero|jardin central|los jardines|fildeador)/.test(n)){setP('posicion','outfield')}
if(/(pitcher|lanzador|picher)/.test(n)){setP('posicion','pitcher')}
if(/primera base/.test(n)){setP('posicion','primera')}
if(/(catcher|receptor|quecher)/.test(n)&&!/(kit|careta|peto|espinillera|casco)/.test(n)){setP('posicion','catcher')}
if(/(fastpitch|bola rapida)/.test(n)){setP('fp','si')}
}
/* ---------- v6.1 VALIDACIÓN POR PRODUCT TYPE (falla del 3-ago: "guante softbol" traía correas/ligas/aceites
   porque el título dice "guante"). Listas blancas de TIPOS REALES del catálogo por categoría del flujo.
   Se evalúan sobre norm(productType). Si el tipo no viene, el título anclado al inicio decide la exclusión. ---------- */
var TYPERULES={
guante:{ok:/^(guante($|\s)|mascota($|\s))/,bad:/^(correa|liga|cera|aceite|kit|tratamiento|balsamo|guantelet|portaguantelet|brocha|pomada|grasa|acondicionador)/},
bat:{ok:/^bat($|\s)/,bad:/^(batera|pesa|cinta|manga|porta|soporte|grip|guantelet|tape)/},
casco:{ok:/^cascos?($|\s)/,bad:/^(porta|protector)/},
spikes:{ok:/^(spikes|tenis)($|\s)/,bad:/^(limpiador|protector|calceta|media)/},
guanteletas:{ok:/^guanteleta/,bad:/^portaguantelet/},
pelotas:{ok:/^pelota($|\s)/,bad:/^(aspiradora|contenedor|exhibidor|bolsa|forro|maquina|malla)/},
kit:{ok:/^(careta|pechera|espinillera|equipo (de )?catcher|cojin catcher)/,bad:null},
accguante:{ok:/^(aceite|cera|correa|liga para|kit|tratamiento|brocha|pomada|grasa|acondicionador)/,bad:null},
maleta:{ok:/^(batera|back ?pack|maleta|mochila|bolsa($|\s))/,bad:/^bolsa para bolas/}
};
var CATFB={guante:'guante',bat:'bat',casco:'casco',spikes:'spikes',guanteletas:'guanteletas',pelotas:'pelotas',kit:'equipo catcher',accguante:'aceite guante',maleta:'batera'};
var fbGuard='';
/* ---------- v7.0 CANDADO DURO DE DEPORTE ----------
   EL BUG (reportado por Karina 7-ago): "pedí un bate COMPUESTO DE SOFTBALL y me recomendó
   de BÉISBOL". Causa raiz: el filtro de deporte vivia dentro de filterProfile() usando
   apply(), que si dejaba menos de 2 productos SOLTABA el pool entero — o sea, al combinar
   deporte + material el deporte se perdia. Ademas el orden de los filtros hacia que el
   material recortara primero.
   ARREGLO: deporteLock() es un filtro DURO que corre ANTES que todo lo demas y del que no
   hay marcha atras. Se apoya en el PRODUCT TYPE (candado duro), no en palabras del titulo:
   el catalogo tiene tipos separados — "Bat Softball" / "Bat Softball Infantil" contra
   "Bat Beisbol / Bat Madera / Bat Adulto / Bat Infantil / Bat Juvenil / Bat Grafito...",
   y "Guante Softball" / "Guante Zurdo Softbol" contra los de beisbol.
   Si el candado deja el pool vacio NO se muestra el deporte equivocado: se vuelve a buscar
   con la query del deporte correcto (rebusca), y si aun asi no hay, se dice la verdad. */
var TYPE_SB=/(softb|fastpitch|slowpitch)/;      /* tipos claramente de softbol */
var TYPE_DAMA=/(dama|femenil)/;                  /* equipo de catcher dama = softbol */
function esSoftbol(p){
var t=typeOf(p);
if(t&&TYPE_SB.test(t)){return true}
if(t&&TYPE_DAMA.test(t)){return true}
var blob=((p.__tags||[]).join(' ')+' '+norm(p.title));
return TYPE_SB.test(blob)}
function esBeisbolPuro(p){
/* Muchos titulos dicen "Beisbol Softbol" (doble uso): esos SI sirven para beisbol.
   Solo se descarta lo que es EXCLUSIVO de softbol. */
var t=typeOf(p);
if(t&&TYPE_SB.test(t)){return false}
if(t&&TYPE_DAMA.test(t)){return false}
var blob=((p.__tags||[]).join(' ')+' '+norm(p.title));
if(TYPE_SB.test(blob)&&!/(beisbol|baseball)/.test(blob)){return false}
return true}
/* Categorias donde el deporte SI parte el catalogo. En calzado no: el mismo spike sirve
   para beisbol y para softbol (lo que manda es la suela y el numero). */
var DEP_APLICA={bat:1,guante:1,casco:1,kit:1,pelotas:1,guanteletas:0,spikes:0,maleta:0,accguante:0};
function deporteLock(items){
var P=state.perfil;
if(!P.deporte||P.deporte==='nose'){return items}
if(P.cat&&!DEP_APLICA[P.cat]){return items}
if(P.deporte==='softbol'){return items.filter(esSoftbol)}
return items.filter(esBeisbolPuro)}
/* Query de rebusca cuando el candado deja el pool vacio: se reconstruye desde la categoria
   + el deporte, nunca desde el deporte contrario. */
function qDeporte(){
var P=state.perfil,base=CATFB[P.cat]||P.cat||'equipo';
if(P.deporte==='softbol'){return base+' softbol'}
if(P.deporte==='beisbol'){return base+' beisbol'}
return base}
/* ---------- v7.0 RANKING POR VENTAS REALES ----------
   Karina 7-ago: "que cheque de su categoria y cuales son los MAS VENDIDOS".
   FUENTE: Shopify Analytics (run-analytics-query), pedidos de los ULTIMOS 365 DIAS
   agrupados por product_id + product_type, cruzados contra el Admin API para quedarnos
   SOLO con los que hoy estan ACTIVE y con inventario. Medido el 7-ago-2026.
   POR QUE UN MAPA Y NO UNA API: la tienda no expone un endpoint publico de best sellers
   (las colecciones estan en CREATED_DESC, no en BEST_SELLING) y no hay backend. El mapa
   es chico, esta fechado y se AUTO-CURA: solo puntua handles que de verdad aparecieron en
   los resultados vivos, asi que un producto que se agote o se archive simplemente deja de
   sumar — nunca "recomienda" algo muerto.
   COMO SE REGENERA (documentado tambien en equipo_shopify_handoffs.md):
     1. run-analytics-query: FROM sales SHOW orders GROUP BY product_id, product_type
        WHERE product_type IN (...) ORDER BY orders DESC LIMIT 30 SINCE -365d UNTIL today
     2. nodes(ids:[...]) del Admin API -> quedarse con status ACTIVE y totalInventory>0
     3. pegar los handles aqui en orden y actualizar TOPVENTAS_AL. */
var TOPVENTAS_AL='2026-08-07';
var TOPVENTAS={
guante:['guante-beisbol-franklin-mlb-team-con-pelota-de-espuma','guante-beisbol-softbol-rawlings-wrs125hbgg-12-5-in-adulto','guante-beisbol-franklin-rtp-performance-series-con-pelota-de-espuma-lanzador-derecho','guante-beisbol-wilson-a500-wbw10253811-11-in-juvenil-11-a-15-anos','guante-beisbol-franklin-ctz5000-verde-rosa','guante-beisbol-wilson-a900-wbw10257112-pedroia-fit-12-in','guante-beisbol-diamante-5003-11-5-in'],
bat:['bat-beisbol-baum-negro-dorado-grafito-adulto','bat-beisbol-reforzado-con-fibra-de-vidrio-beisbolmania-compuesto-maple-bamboo-bm110-negro-amarillo','bat-beisbol-reforzado-con-fibra-de-vidrio-beisbolmania-compuesto-maple-bamboo-bm271-celeste-marino','bat-beisbol-louisville-slugger-omaha-sandia-wtlbbo5155i-aluminio-adulto-5','bat-beisbol-reforzado-con-fibra-de-vidrio-beisbolmania-maple-plus-bm243-negro-mate-adulto','bat-beisbol-reforzado-con-fibra-de-vidrio-beisbolmania-birch-plus-bmap5-negro-plata'],
casco:['casco-beisbol-rawlings-mach-1-oreja-bateador-derecho','casco-beisbol-softbol-easton-z50-z50matmjg-mate-ajustable-con-protector-de-mandibula-bateador-derecho-zurdo','casco-beisbol-softbol-champro-hxm2jg-legend-plus-mate-con-protector-de-mandibula-bateador-derecho-zurdo','casco-beisbol-softbol-easton-z50-mate','casco-beisbol-softbol-easton-alpha','casco-beisbol-rawlings-mach-fit-osfm-ajustable-6-7-8-7-5-8-rey','casco-beisbol-softbol-champro-hxmjg-gamer-plus-mate','casco-beisbol-softbol-easton-pro-max-pmxmjg-mate-ajustable-con-protector-de-mandibula-bateador-derecho-zurdo','casco-beisbol-softbol-marucci-duravent-mbhdvjg-con-protecor-quijada-negro','casco-beisbol-softbol-rawlings-coolflo-rcfh'],
spikes:['spikes-beisbol-new-balance-ohtani-1-blanco-dorado','tenis-de-entrenamiento-beisbol-softbol-new-balance-fuelcell-ohtani-1-blanco-dorado','spikes-beisbol-softbol-new-balance-fuelcell-4040-v8-molded-blanco','spikes-beisbol-softbol-nike-jordan-1-blanco','spikes-beisbol-softbol-under-armour-harper-10-rm-mid-blanco-gris','spikes-beisbol-new-balance-fuelcell-ohtani-1-metal-rey','spikes-beisbol-new-balance-fuelcell-ohtani-1-msho5go-metal','spikes-beisbol-air-jordan-1-retro-plastico','spikes-beisbol-softbol-nike-jordan-1-rojo-blanco-infantil','spikes-beisbol-softbol-nike-jordan-1-dorado-negro-infantil'],
guanteletas:['guanteletas-beisbol-franklin-cfx-pro-hi-lite-morado-adulto','guanteletas-beisbol-franklin-powerstrap-infinite-series-naranja-verde','guanteletas-beisbol-marucci-pwr-fade-mbgpwrf-adulto','guanteletas-beisbol-franklin-grow-2-pro-blanco-rosa-morado-infantil'],
kit:['equipo-de-catcher-beisbol-champro-optimus-champion-cbsn4-select-12-a-16-anos','equipo-de-catcher-beisbol-champro-optimus-champion-cbsn4-select-9-a-12-anos'],
pelotas:['docena-pelotas-beisbol-softbol-america-1000','docena-de-pelotas-beisbol-america-185-piel','pelota-beisbol-de-piel-comando']};
function topRank(p){
var cat=state.perfil.cat;if(!cat||!TOPVENTAS[cat]){return 0}
var h=handleFromUrl(p.url);if(!h){return 0}
var i=TOPVENTAS[cat].indexOf(h);
return i<0?0:(i+1)}
function typeOf(p){return norm(p.__type||'')}
function typePass(p,cat){
var R=TYPERULES[cat];if(!R){return true}
var t=typeOf(p);
if(t){return R.ok.test(t)&&!(R.bad&&R.bad.test(t))}
return !(R.bad&&R.bad.test(norm(p.title)))}
var CATRULES=[
{re:/(guanteleta|(guante|guantes).{0,12}(bateo|batear)|de bateo)/,q:'guanteletas',cat:'guanteletas',i:'Para batear van <b>guanteletas</b> (no guante de fildeo): mejor grip y cero ampollas.'},
{re:/(kit (de )?catcher|careta|peto|espinillera|arreos)/,f:'catcherkit',q:'equipo catcher',cat:'kit'},
/* v6.1: cuidado/accesorios del guante ANTES que guante — aquí los accesorios SÍ son la respuesta correcta */
{re:/((correas?|ligas?)\s+(para|de)\s+(el\s+|mi\s+|tu\s+|sujetar\s+)?(guante|manopla|mascota))/,q:'correa guante',cat:'accguante',i:'Va — correas y ligas para dejar el guante bien armado:'},
{re:/((cuidar|mantener|limpiar|amansar|ablandar|moldear|engrasar|hidratar|proteger)(\w*)?\s.{0,24}(guante|manopla|mascota)|(aceite|cera|balsamo|acondicionador|tratamiento)\s+(para\s+)?(el\s+|mi\s+|tu\s+)?(guante|manopla|mascota)|glovolium)/,q:'aceite guante',cat:'accguante',i:'Para consentir el guante va esto — aceite, cera y tratamiento lo mantienen suave y durable:'},
{re:/(manopla|mascota|guante)/,f:'guante',q:'guante',cat:'guante'},
{re:/(^|\s)(bat|bats|bate|bates|madero)(\s|$|[.,!?])/,f:'bat',q:'bat',cat:'bat'},
{re:/(spike|spikes|tacos|tachon|cleat|turf|tenis)/,f:'spikes',q:'spikes',cat:'spikes'},
{re:/(^|\s)(cascos?|helmet)(\s|$|[.,!?])/,f:'casco',q:'casco',cat:'casco'},
{re:/(^|\s)(pelotas?|bolas?)(\s|$|[.,!?])/,q:'pelotas',cat:'pelotas'},
{re:/(mochila|maleta|backpack|batera|bolsa)/,q:'maleta',cat:'maleta'},
{re:/(catcher|receptor|quecher)/,f:'catcherkit',q:'equipo catcher',cat:'kit'},
{re:/(softbol|softball)/,f:'softbol',q:'softbol'}
];
function catRule(n){for(var i=0;i<CATRULES.length;i++){if(CATRULES[i].re.test(n)){return CATRULES[i]}}return null}
function buildQuery(base){
var P=state.perfil,q=base,nb=norm(base);
if(P.deporte==='softbol'&&nb.indexOf('softbol')===-1&&nb.indexOf('fastpitch')===-1){q+=' softbol'}
if(P.quien==='nino4'&&!/infantil|juvenil/.test(base)){q+=' infantil'}
else if((P.quien==='nino9'||P.quien==='juvenil')&&!/infantil|juvenil/.test(base)){q+=' juvenil'}
return q}
/* ---------- Log de conversaciones a Odoo (falla en silencio) ---------- */
function plain(h){var d=document.createElement('div');d.innerHTML=String(h||'');return (d.textContent||d.innerText||'').replace(/\s+/g,' ').trim()}
function odooLog(isLead){
try{
var ms=conv.slice(-30).map(function(m){return {de:m.w==='user'?'cliente':'bot',texto:plain(m.h).slice(0,600),ts:m.ts||new Date().toISOString()}}).filter(function(m){return m.texto});
if(!ms.length){return}
var body={
sesion:SES,
nombre:(lead&&lead.n)||'',
contacto:(lead&&lead.c)||'',
lead:!!(isLead||(lead&&lead.c)),
pagina:location.href,
mensajes:ms
};
var pt=perfilTexto();
if(pt){body.perfil=pt}
if(state.leadEtapa){body.etapa=state.leadEtapa}
fetch(ODOO_LOG,{method:'POST',keepalive:true,headers:{'Content-Type':'application/json'},body:JSON.stringify(body)}).catch(function(){});
lastLogged=conv.length;
}catch(e){}}
function odooLogIfWorth(){if(conv.length>=3&&conv.length!==lastLogged){odooLog(false)}}
/* ---------- Leads: KLAVIYO PRIMERO (fuente de verdad); /contact secundario best-effort ---------- */
function klaviyoLead(n,c){
try{
var isMail=c.indexOf('@')>-1;
if(isMail){
return fetch('https://a.klaviyo.com/client/subscriptions/?company_id='+KLAVIYO_CO,{method:'POST',headers:{'revision':'2024-10-15','Content-Type':'application/json'},body:JSON.stringify({
data:{type:'subscription',attributes:{custom_source:'EL CATCHER (chatbot beisbolmania.mx)',profile:{data:{type:'profile',attributes:{email:c,first_name:n}}}},relationships:{list:{data:{type:'list',id:KLAVIYO_LIST}}}}
})}).then(function(r){return r.ok}).catch(function(){return false});
}
var d=c.replace(/\D/g,'');
if(d.length<10){return Promise.resolve(false)}
var tel='+52'+d.slice(-10);
return fetch('https://a.klaviyo.com/client/events/?company_id='+KLAVIYO_CO,{method:'POST',headers:{'revision':'2024-10-15','Content-Type':'application/json'},body:JSON.stringify({
data:{type:'event',attributes:{properties:{nombre:n,pagina:location.href,origen:'EL CATCHER',perfil:perfilTexto()},metric:{data:{type:'metric',attributes:{name:'Lead Catcher'}}},profile:{data:{type:'profile',attributes:{phone_number:tel,first_name:n}}}}}
})}).then(function(r){return r.ok}).catch(function(){return false});
}catch(e){return Promise.resolve(false)}}
function sendLead(n,c,f){
var isMail=c.indexOf('@')>-1;
var hist=conv.filter(function(m){return m.w==='user'}).slice(-6).map(function(m){return '- '+m.h.replace(/<[^>]+>/g,'')}).join('\n');
var pt=perfilTexto();
var body='LEAD del Cátcher (chatbot beisbolmania.mx)\n\nNombre: '+n+'\n'+(isMail?'Correo: ':'WhatsApp: ')+c+'\n'+(pt?'\nPerfil del cliente: '+pt+'\n':'')+'\nÚltimos mensajes del cliente:\n'+(hist||'(sin mensajes)')+'\n\nPágina: '+location.href;
var fd=new FormData();
fd.append('form_type','contact');
fd.append('utf8','✓');
fd.append('contact[email]',isMail?c:'lead-catcher@beisbolmania.mx');
fd.append('contact[Nombre]',n);
fd.append('contact[Telefono]',isMail?'(no dio)':c);
fd.append('contact[body]',body);
odooLog(true);
/* Klaviyo es el canal principal; el form /contact solo suma. Si CUALQUIERA entra, es éxito. */
var pKlav=klaviyoLead(n,c);
var pForm=fetch('/contact#contact_form',{method:'POST',body:fd}).then(function(r){return r.ok}).catch(function(){return false});
Promise.all([pKlav,pForm]).then(function(res){
var ok=res[0]||res[1];
if(ok){
/* v7.0: se guarda la ETAPA en la que se capturo el lead (productos / carrito / talla /
   envio / stock / humano / suave) — sirve para medir que copy convierte. */
lead={n:n,c:c,at:Date.now(),etapa:state.leadEtapa||state.leadCtx||''};lsSet('bmcLead',lead); /* sin expiración: registrado una vez, abierto siempre */
state.leadEtapa=lead.etapa;saveState();
if(f&&f.parentNode){f.remove()}
if(state.leadCtx==='candado'){lockInput(false);botSay('¡Eso, <b>'+esc(n)+'</b>! Chat desbloqueado — quedas como cliente VIP y te aviso de promos antes que a nadie. Ahora sí: ¿qué andas buscando hoy?',chips)}
else if(state.leadCtx==='inicio'){botSay('¡Eso, <b>'+esc(n)+'</b>! Quedas apuntado como VIP: te aviso de promos antes que a nadie. Ahora sí — ¿qué andas buscando hoy?',chips)}
else{botSay('¡Atrapado! Gracias <b>'+esc(n)+'</b>, ya le pasé tus datos al equipo y te contactamos en breve. Mientras, ¿te ayudo a buscar algo más?',chips)}
}else{
var bt=f&&f.querySelector('button');if(bt){bt.disabled=false}
botSay('No pude registrar tus datos por una falla de conexión. Escríbenos directo por WhatsApp y te atendemos al momento:<br>'+waBtn('Hola, soy '+n+' ('+c+') y quiero ayuda con mi compra'));
}
})}
/* ---------- Carrito: agregar desde las tarjetas y empujar el cierre ---------- */
function cartNudge(){
fetch('/cart.js').then(function(r){return r.json()}).then(function(cart){
var t=(cart&&cart.total_price)||0;
var h;
if(t>=ENVIO_GRATIS){h='Tu envío ya va <b>GRATIS</b> (compras desde '+money(ENVIO_GRATIS)+').'}
else{h='Te faltan <b>'+money(ENVIO_GRATIS-t)+'</b> para llevarte el envío <b>GRATIS</b> (desde '+money(ENVIO_GRATIS)+'). ¿Le sumamos algo?'}
if(t>=MSI_MIN){h+='<br>Y ojo: tu compra ya alcanza <b>meses sin intereses</b> — a partir de 3 meses, pagando con tarjeta en el checkout.'}
h+='<br><a class="bmc-wabtn bmc-checkout" href="/checkout">Finalizar compra</a> <a class="bmc-wabtn bmc-seguir" href="#" data-seguir>Seguir viendo</a>';
push('bot',h);
/* v7.0: agregar al carrito es EL momento natural para el reintento del lead */
setTimeout(function(){enqueueTurn(function(){leadTrasValor('carrito')})},2400);
}).catch(function(){
push('bot','Listo, quedó en tu carrito. <a class="bmc-wabtn bmc-checkout" href="/checkout">Finalizar compra</a>')
})}
/* ---------- Venta cruzada con lógica de vendedor ---------- */
var XSELL=[
{re:/(manopla|guante|mascota)/i,not:/(bateo|guanteleta)/i,qs:['aceite guante','pelotas beisbol'],pitch:'Pro-tip: un guante nuevo <b>se amansa con aceite o formador</b> — cierra mejor desde el primer juego. Y unas pelotas para ablandarlo practicando:'},
{re:/(^|\s)bate?s?(\s|$)|bat /i,not:/(bateo|guanteleta)/i,qs:['guanteletas','grip'],pitch:'Con bat nuevo van <b>guanteletas de bateo</b>: mejor grip, cero ampollas y más control del swing.'},
{re:/(spike|turf|cleat|tacho)/i,not:null,qs:['calcetas beisbol','agujetas'],pitch:'Para estrenar spikes: <b>calcetas largas de juego</b> — completan el uniforme y evitan rozaduras.'},
{re:/(casco|helmet)/i,not:null,qs:['bolsa beisbol','maleta beisbol'],pitch:'Para que el casco no ande rodando ni se raye: una <b>bolsa o maleta de equipo</b> lo cuida camino al juego.'},
{re:/(catcher|careta|peto|espinillera)/i,not:/(manopla|guante|mascota)/i,qs:['maleta beisbol'],pitch:'Todo ese equipo de catcher necesita en qué viajar: una <b>maleta de equipo</b> le queda perfecto.'}];
/* v6: dato técnico clave visible en cada tarjeta (drop / pulgadas / sello / talla) */
function specFor(p){
var tg=p.__tags||[],t=norm(p.title),out=[],i,m;
for(i=0;i<tg.length;i++){if(/^drop -?\d+$/.test(tg[i])){out.push(tg[i].toUpperCase());break}}
if(!out.length){m=t.match(/drop\s*[- ]?\s*(\d{1,2})/);if(m){out.push('DROP -'+m[1])}}
var gotIn=false;
for(i=0;i<tg.length;i++){if(/^\d{1,2}(\.\d{1,2})? in$/.test(tg[i])){out.push(tg[i].toUpperCase());gotIn=true;break}}
if(!gotIn){m=t.match(/(\d{1,2}(?:\.\d{1,2})?)\s*(?:pulgadas|pulg\b|inches|inch|in\b|")/);if(m){var iv=parseFloat(m[1]);if(iv>=8&&iv<=36){out.push(m[1]+' IN')}}}
var sellos=['bbcor','usssa','usa bat','fastpitch','slowpitch','asa'];
for(i=0;i<sellos.length;i++){if(out.length>=2){break}if(t.indexOf(sellos[i])>-1||tg.indexOf(sellos[i])>-1){out.push(sellos[i].toUpperCase());break}}
var edades=['adulto','juvenil','infantil','panalitos'];
for(i=0;i<edades.length;i++){if(out.length>=2){break}if(tg.indexOf(edades[i])>-1){out.push(edades[i]==='panalitos'?'PAÑALITOS':edades[i].toUpperCase());break}}
return out.slice(0,2).join(' · ')}
function prodCards(items){
return '<div class=bmc-prods>'+items.map(function(p){
var img=(p.featured_image&&p.featured_image.url)||p.image||'';
if(img){img=img+(img.indexOf('?')>-1?'&':'?')+'width=200'}
var handle=handleFromUrl(p.url);
var spec=specFor(p);
return '<div class=bmc-card>'+(img?'<img loading=lazy src="'+esc(img)+'" alt="">':'')+'<div class=bmc-card-t>'+esc(p.title)+'</div>'+(spec?'<div class=bmc-card-spec>'+esc(spec)+'</div>':'')+(p.__why?'<div class=bmc-card-why>'+p.__why+'</div>':'')+'<div class=bmc-card-p>$'+esc(p.price)+' MXN</div><button type=button class=bmc-add data-handle="'+esc(handle)+'" data-url="'+esc(p.url)+'">Agregar al carrito</button><a class=bmc-card-view href="'+esc(p.url)+'" data-view="'+esc(p.title)+'">Ver producto &rarr;</a></div>'
}).join('')+'</div>'}
function suggest(q,limit,cb){
netPend++;actMark();
function netDone(){netPend--;actMark()}
fetch('/search/suggest.json?q='+encodeURIComponent(q)+'&resources[type]=product&resources[limit]='+(limit||10))
.then(function(r){return r.json()})
.then(function(d){
var items=(d&&d.resources&&d.resources.results&&d.resources.results.products)||[];
items=items.filter(function(p){return p.available!==false});
/* v6.1: suggest.json ya trae type y tags — se siembran aquí y la validación por tipo corre sin fetch extra */
items.forEach(function(p){
if(p.type!=null&&!p.__type){p.__type=p.type}
if(p.tags&&p.tags.length&&!p.__tags){p.__tags=p.tags.map(norm)}
});
cb(items);netDone()
}).catch(function(){cb(null);netDone()})}
function crossSell(title){
var t=String(title||'');
var x=null;
for(var i=0;i<XSELL.length;i++){if(XSELL[i].re.test(t)&&(!XSELL[i].not||!XSELL[i].not.test(t))){x=XSELL[i];break}}
if(!x){return}
var pend=x.qs.length,found=[];
x.qs.forEach(function(q){suggest(q,2,function(items){
if(items&&items.length){found=found.concat(items.slice(0,2))}
pend--;
if(pend===0&&found.length){
var seen={},uniq=found.filter(function(p){if(seen[p.url]){return false}seen[p.url]=1;return true}).slice(0,3);
if(uniq.length){typing(function(){push('bot',x.pitch+prodCards(uniq),'bmc-wide')})}
}
})})}
function handleFromUrl(u){var p=String(u||'').split('/products/')[1]||'';return p.split('?')[0].split('/')[0]}
function addToCart(btn){
var url=btn.getAttribute('data-url')||'';
var handle=btn.getAttribute('data-handle')||handleFromUrl(url);
if(!handle){location.href=url;return}
btn.disabled=true;var old=btn.textContent;btn.textContent='…';
fetch('/products/'+handle+'.js').then(function(r){if(!r.ok){throw 0}return r.json()}).then(function(p){
var vs=(p&&p.variants)||[];
var avail=vs.filter(function(v){return v.available});
if(!avail.length){btn.textContent='Agotado';botSay('Uy, ese se acaba de agotar. Déjame tus datos y te aviso cuando caiga de nuevo, o pregúntanos por WhatsApp:<br>'+waBtn('Hola, ¿cuándo llega de nuevo '+p.title+'?'));return}
if(vs.length>1){
var a=document.createElement('a');a.className='bmc-add';a.href=url||('/products/'+handle);a.textContent='Elegir talla';
btn.parentNode.replaceChild(a,btn);
botSay('Ese viene en varias tallas/versiones — dale a <b>Elegir talla</b> y escoge la tuya en la ficha. Ahí mismo está la guía de medidas.');
return}
return fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:avail[0].id,quantity:1})}).then(function(r){
if(!r.ok){throw 0}
btn.textContent='En el carrito';
state.fail=0;state.miss=0;saveState();
push('bot','¡Ponchado! <b>'+esc(p.title)+'</b> ya está en tu carrito.');
document.dispatchEvent(new CustomEvent('cart:refresh'));
cartNudge();
setTimeout(function(){enqueueTurn(function(){crossSell(p.title)})},1200);
})
}).catch(function(){
btn.disabled=false;btn.textContent=old;
botSay('No pude agregarlo desde aquí, pero en su ficha va directo:<br><a class="bmc-wabtn bmc-seguir" href="'+esc(url)+'">Ver producto</a>')
})}
/* ---------- TAGS CANÓNICOS del catálogo: el perfil FILTRA los resultados ---------- */
var TAG_MAT_ALL=['bat madera','maple','bamboo','birch','aluminio','compuesto metal'];
var TAG_MAT={madera:['bat madera','maple','bamboo','birch'],aluminio:['aluminio'],compuesto:['compuesto metal']};
var TAG_AGE_ALL=['adulto','juvenil','infantil','panalitos'];
var TAG_AGE={nino4:['infantil','panalitos'],nino9:['infantil','juvenil'],juvenil:['juvenil'],adulto:['adulto']};
var TAG_MANO_ALL=['zurdo','diestro'];
var TAG_MANO={LHT:['zurdo'],RHT:['diestro']};
function enrichTags(items,cb){
var pend=0,list=items.slice(0,10);
list.forEach(function(p){
if(p.__tags&&p.__type){return} /* v6.1: suggest.json ya lo trajo — cero fetches extra */
var h=handleFromUrl(p.url);
if(!h){return}
pend++;netPend++;actMark();
fetch('/products/'+h+'.js').then(function(r){if(!r.ok){throw 0}return r.json()}).then(function(d){
p.__tags=((d&&d.tags)||[]).map(norm);
if(d&&d.type&&!p.__type){p.__type=d.type}
}).catch(function(){}).then(function(){pend--;netPend--;actMark();if(pend===0){cb(items)}});
});
if(!pend){cb(items)}
}
/* ---------- v7.0 FILTRO POR TALLA DISPONIBLE (spikes/calzado) ----------
   Karina: "mandarle opciones DE SU TALLA". No basta que el producto exista: la VARIANTE de
   su numero tiene que estar disponible. Se lee /products/<handle>.js (variantes + available)
   y se marca p.__tallaOk / p.__tallaTxt. Las variantes vienen como "#26 MX", "#26.5 MX",
   a veces con color u otra opcion pegada, por eso se compara el numero, no la cadena. */
function tallaDeVariante(v){
var t=norm((v&&(v.title||''))+' '+((v&&v.options)?v.options.join(' '):''));
var m=t.match(/#?\s*(\d{1,2}(?:\.\d)?)\s*mx/);
if(!m){m=t.match(/#\s*(\d{1,2}(?:\.\d)?)/)}
if(!m){return 0}
var n=parseFloat(m[1]);
return (n>=15&&n<=34)?n:0}
function filtraPorTalla(items,talla,cb){
var pend=0,list=items.slice(0,10);
list.forEach(function(p){
var h=handleFromUrl(p.url);
if(!h){p.__tallaOk=false;return}
pend++;netPend++;actMark();
fetch('/products/'+h+'.js').then(function(r){if(!r.ok){throw 0}return r.json()}).then(function(d){
var vs=(d&&d.variants)||[];
p.__tallaOk=false;
for(var i=0;i<vs.length;i++){
if(!vs[i].available){continue}
if(tallaDeVariante(vs[i])===talla){p.__tallaOk=true;break}
}
}).catch(function(){p.__tallaOk=false}).then(function(){pend--;netPend--;actMark();if(pend===0){cb(list)}});
});
if(!pend){cb(list)}
}
function dimPass(p,all,ok,badRe){
var tg=p.__tags||[],dims=[],i;
for(i=0;i<tg.length;i++){if(all.indexOf(tg[i])>-1){dims.push(tg[i])}}
if(!dims.length){if(badRe&&badRe.test(norm(p.title))){return false}return true}
for(i=0;i<dims.length;i++){if(ok.indexOf(dims[i])>-1){return true}}
return false}
function filterProfile(items){
var P=state.perfil,pool=items.slice(),notes=[];
function apply(fn,label){
var kept=pool.filter(fn);
if(kept.length>=2){pool=kept}
else{notes.push(label);
if(kept.length===1){pool=kept.concat(pool.filter(function(x){return x!==kept[0]}))}}
}
var blob=function(p){return ((p.__tags||[]).join(' ')+' '+norm(p.title))};
if(P.material&&TAG_MAT[P.material]){
var bad=P.material==='madera'?/(aluminio|alloy|composite|compuesto|hibrido)/:/(mader|maple|bamboo|bambu|birch)/;
apply(function(p){return dimPass(p,TAG_MAT_ALL,TAG_MAT[P.material],bad)},'de '+P.material)}
/* v7.0: el DEPORTE YA NO se filtra aqui. Vive en deporteLock(), que es DURO y corre antes.
   Dejarlo aqui era el bug: apply() lo soltaba en cuanto quedaban menos de 2 productos. */
/* v6 CASCOS: tags canónicos tipo "Casco Adulto"/"Casco Softbol" — filtro por subcadena en tags+título */
if(P.cat==='casco'){
var AGE_RE={adulto:/adult/,juvenil:/(juvenil|youth|junior|(^|\s)jr)/,nino9:/(infantil|nin[oa])/,nino4:/(panalito|t.?ball)/,dama:/(dama|femenil|mujer)/};
if(P.quien&&AGE_RE[P.quien]){apply(function(p){return AGE_RE[P.quien].test(blob(p))},'en talla '+(PLBL.quien[P.quien]||'esa'))}
}
else if(P.quien&&TAG_AGE[P.quien]){apply(function(p){return dimPass(p,TAG_AGE_ALL,TAG_AGE[P.quien],null)},'para '+(PLBL.quien[P.quien]||'esa edad'))}
if(P.mano&&P.cat!=='bat'&&TAG_MANO[P.mano]){apply(function(p){return dimPass(p,TAG_MANO_ALL,TAG_MANO[P.mano],null)},P.mano==='LHT'?'para zurdo':'para diestro')}
if(P.drop){apply(function(p){var tg=p.__tags||[],dims=tg.filter(function(x){return /^drop -?\d+$/.test(x)});if(!dims.length){return true}return dims.indexOf('drop '+P.drop)>-1},'con drop '+P.drop)}
if(P.inch){apply(function(p){var tg=p.__tags||[],dims=tg.filter(function(x){return /^\d{1,2}(\.\d{1,2})? in$/.test(x)});if(!dims.length){return true}return dims.indexOf(P.inch+' in')>-1},'de '+P.inch+' in')}
return {pool:pool,notes:notes}}
/* ---------- Búsqueda con cabeza de VENDEDOR: categoría + perfil + razones ---------- */
var CATWORDS={guante:/(guante|manopla|mascota)/,bat:/(^|\s)bate?s?(\s|$|[.,])/,pelotas:/(pelota|bola)/,spikes:/(spike|cleat|turf|tacho|tenis|calzado)/,casco:/(casco|helmet)/,kit:/(catcher|careta|peto|espinillera|kit)/,maleta:/(maleta|mochila|bolsa|backpack|batera)/,guanteletas:/guantelet/};
function scoreItems(items){
var P=state.perfil,bre=brandRe(P.marca);
items.forEach(function(p,ix){
p.__pr=priceNum(p);p.__ix=ix;
var t=norm(p.title),s=0,c;
if(bre&&bre.test(t)){s+=4}
if(P.budget&&p.__pr>0&&p.__pr<=P.budget){s+=3}
if(P.cat&&CATWORDS[P.cat]){
if(CATWORDS[P.cat].test(t)){s+=5}
else{for(c in CATWORDS){if(c!==P.cat&&CATWORDS[c].test(t)){s-=4;break}}}
}
if(P.material==='madera'){if(/(mader|maple|bamb|birch|abedul)/.test(t)){s+=3}if(/(aluminio|alloy|compuesto|composite|hibrido)/.test(t)){s-=5}}
else if(P.material==='aluminio'){if(/(aluminio|alloy)/.test(t)){s+=3}if(/(mader|maple)/.test(t)){s-=4}}
else if(P.material==='compuesto'){if(/(compuesto|composite)/.test(t)){s+=3}if(/(mader|maple)/.test(t)){s-=4}}
var kid=(P.quien==='nino4'||P.quien==='nino9'||P.quien==='juvenil'||P.genero==='nina'||P.genero==='nino');
if(kid&&/(infantil|juvenil|youth|junior|(^|\s)jr|nin[oa])/.test(t)){s+=2}
if(P.quien==='adulto'&&/(infantil|juvenil|youth|junior|t.?ball)/.test(t)){s-=3}
/* v6: la edad EXACTA pedida manda sobre "cualquier cosa de niño" */
if(P.quien==='juvenil'&&/(juvenil|youth|junior|(^|\s)jr)/.test(t)){s+=3}
if(P.quien==='nino9'&&/infantil/.test(t)){s+=3}
if(P.quien==='nino4'&&/(t.?ball|panalito|infantil)/.test(t)){s+=3}
if(P.quien==='adulto'&&/adult/.test(t)){s+=3}
if(P.deporte==='softbol'&&/(softbol|softball|fastpitch)/.test(t)){s+=2}
if(P.deporte==='beisbol'&&/(softbol|softball|fastpitch)/.test(t)){s-=3}
if(P.mano==='LHT'&&/(lht|zurd|left hand)/.test(t)){s+=2}
/* v7.0: LO MAS VENDIDO manda sobre lo que el buscador ponga primero (Karina 7-ago).
   El rank 1 pesa +7 y va bajando; un producto fuera del mapa simplemente no suma. */
var tr=topRank(p);
if(tr){s+=Math.max(8-tr,2);p.__top=tr}
p.__s=s});
items.sort(function(a,b){return b.__s-a.__s||a.__ix-b.__ix});
return items}
function reasonsFor(pool){
var P=state.perfil,bre=brandRe(P.marca),prev='';
pool.forEach(function(p,i){
var t=norm(p.title),cs=[];
if(P.material&&TAG_MAT[P.material]){
var tg=p.__tags||[];
var matOk=tg.some(function(x){return TAG_MAT[P.material].indexOf(x)>-1});
if(matOk||(P.material==='madera'&&/(mader|maple|bamb|birch)/.test(t))){cs.push('Justo del material que pediste')}}
/* v7.0 (Karina: "mas inteligente al vender"): la razon menciona el DATO QUE EL CLIENTE DIO
   — su talla, su deporte, la edad, la posicion — no frases genericas. */
if(p.__top&&p.__top<=2){cs.push('El que más sale en tu categoría')}
if(P.talla&&p.__tallaOk){cs.push('Disponible en tu '+tallaTxt(P.talla))}
if(P.deporte==='softbol'&&/(softbol|softball|fastpitch)/.test(t)){cs.push('De softbol, como me pediste')}
if(P.posicion&&P.posicion!=='nose'&&P.cat==='guante'){cs.push('Para '+(PLBL.posicion[P.posicion]||'su posición'))}
if(P.suela&&P.cat==='spikes'){cs.push(PLBL.suela[P.suela]?cap(PLBL.suela[P.suela]):'')}
if(bre&&bre.test(t)){cs.push('La marca que buscas')}
if(P.budget&&p.__pr>0&&p.__pr<=P.budget){cs.push('Dentro de tu presupuesto')}
if(P.edad&&/(infantil|juvenil|youth|junior|(^|\s)jr|t.?ball|panalito)/.test(t)){cs.push('En talla para sus '+P.edad+' años')}
else if((P.genero||P.quien==='nino4'||P.quien==='nino9'||P.quien==='juvenil')&&/(infantil|juvenil|youth|junior|(^|\s)jr|t.?ball|panalito)/.test(t)){cs.push('En talla '+(PLBL.quien[P.quien]||'para su edad'))}
if(p.__pr>=ENVIO_PESOS){cs.push('Con envío GRATIS')}
if(p.__top){cs.push('De los más vendidos')}
if(i===0){cs.push('★ Favorito de los clientes')}
cs=cs.filter(Boolean);
var pick='';
for(var k=0;k<cs.length;k++){if(cs[k]!==prev){pick=cs[k];break}}
if(!pick){pick=cs[0]||''}
p.__why=pick;prev=pick})}
function ctxLine(){
var P=state.perfil,who=segTxt(),l;
if(who){l='Para '+who+' estos son los ideales — talla y peso correctos para su edad:'}
else if(P.marca&&P.budget){l='Con la marca y el presupuesto que me pediste, esto es lo mejor que traigo:'}
else if(P.marca){l='Puro '+esc(cap(P.marca))+' del bueno — esto es lo que te recomiendo:'}
else if(P.budget){l='Cuidando tu presupuesto de $'+fmt(P.budget)+', estos son los mejores:'}
else if(P.cheap){l='Buscando lo más accesible sin sacrificar calidad, va:'}
else{l='Esto fue lo que atrapé para ti:'}
if(P.mano==='LHT'&&P.cat==='guante'){l+='<br>Ojo: al lanzar con la zurda el guante va en la mano derecha — en la ficha elige la versión <b>LHT</b>.'}
return l}
function advanceQ(pool){
var P=state.perfil,msi=false,i;
for(i=0;i<pool.length;i++){if(pool[i].__pr>=MSI_PESOS){msi=true;break}}
/* v7.0: nunca cerramos en seco — la ultima linea SIEMPRE mueve la venta un paso.
   Se pide primero el dato que falta (talla > presupuesto), y si no falta nada, el cierre. */
var h;
if(P.cat==='spikes'&&!P.talla){h='¿Cuál te late? Dime tu número (talla MX) y te digo cuál sí tengo en tu talla ahorita.'}
else if(!P.budget&&!P.cheap){h='¿Te late alguno, o te los filtro por precio?'}
else{h='¿Te late alguno o afinamos?'}
if(msi){h+='<br>Y acuérdate: en compras desde <b>'+money(MSI_MIN)+'</b> lo pagas <b>a partir de 3 meses sin intereses</b> con tarjeta en el checkout.'}
state.await='afinar';saveState();
botSay(h,function(){
push('bot','<div class=bmc-chips><button type=button data-af=precio>Por precio</button><button type=button data-af=marca>Por marca</button><button type=button data-act=menu>Ver el menú</button><button type=button data-act=humano>Hablar con humano</button></div>','bmc-bare');
/* v7.0 LEAD: acabamos de dar VALOR (productos con foto y precio) — este es el momento */
setTimeout(function(){enqueueTurn(function(){leadTrasValor('productos')})},1400);
})}
function noResults(q,intro){
state.miss++;saveState();
push('bot',(intro?intro+'<br>':'')+'De eso ahorita no tengo en línea, pero me la anoto para el equipo — por WhatsApp te lo consiguen al momento:<br>'+waBtn('Hola, en beisbolmania.mx busco: '+q));
chips()}
function setLast(pool){
state.last={qBase:lastQBase,cat:state.perfil.cat||'',med:median(pool.map(function(p){return p.__pr})),brands:brandsIn(lastAll.length?lastAll:pool)};
saveState()}
/* v7.0: TODA ruta de refinamiento pasa por aqui, y aqui se garantiza el minimo de 3.
   Si el refinamiento deja menos de 3, se completa con lo mas parecido del mismo pool base
   (que ya trae el candado de deporte puesto) DICIENDOLO — jamas entregar 2 pelones. */
function renderPool(pool,head,base){
pool=pool.slice(0,MAXP);
if(pool.length<MINP){
var extra=(base||profBase()).filter(function(p){return pool.indexOf(p)<0});
if(extra.length){
var falta=MAXP-pool.length;
pool=pool.concat(extra.slice(0,falta));
head=(head?head+'<br>':'')+'De eso exacto me queda poquito, así que <b>te muestro también estos parecidos</b>:'}
}
if(!pool.length){return}
reasonsFor(pool);
state.miss=0;
push('bot',(head?head:'')+prodCards(pool),'bmc-wide');
setLast(pool);
advanceQ(pool)}
function renderResults(items,q,intro,pre){
var P=state.perfil;
/* v6.1 NUNCA INVENTAR, ahora ESTRUCTURAL: pidió una categoría = SOLO productos cuyo PRODUCT TYPE
   está en la lista blanca de esa categoría. Un accesorio jamás se cuela aunque el título diga "guante".
   Si tras filtrar queda poco, se amplía DICIÉNDOLO — pero un tipo excluido no se muestra jamás. */
if(P.cat&&TYPERULES[P.cat]){
var okT=items.filter(function(p){return typePass(p,P.cat)});
if(!okT.length){
/* v6.1: antes de rendirnos, UNA búsqueda de respaldo con la query base de la categoría */
var fb=CATFB[P.cat];
if(fb&&fbGuard!==P.cat&&norm(lastQBase||'')!==fb){fbGuard=P.cat;searchProducts(fb,intro);return}
noResults(q||P.cat,intro);return}
fbGuard='';
if(okT.length<2&&items.length>okT.length){pre=(pre?pre+'<br>':'')+'De eso exacto me queda poquito en línea — esto es lo que traigo:'}
items=okT;
}
/* respaldo v6 para cascos sin type: el título manda */
if(P.cat==='casco'){
var soloCascos=items.filter(function(p){return typeOf(p)?true:/(casco|helmet)/.test(norm(p.title))});
if(soloCascos.length){items=soloCascos}
else{noResults(q||'casco',intro);return}
}
/* ---------- v7.0 CANDADO DURO DE DEPORTE (el fix del bug de Karina) ----------
   Corre ANTES de scoreItems y de filterProfile. Del deporte no hay marcha atras: si el
   cliente fijo softbol, de aqui NO sale un solo producto de beisbol, y al reves igual. */
if(P.deporte&&P.deporte!=='nose'){
var dep=deporteLock(items);
if(!dep.length){
/* nada del deporte correcto en esta busqueda: NO mostramos el contrario — rebuscamos */
var qd=qDeporte();
if(fbGuard!=='dep:'+qd&&norm(lastQBase||'')!==norm(qd)){fbGuard='dep:'+qd;searchProducts(qd,intro);return}
noResults(qd,intro);return}
items=dep;
}
if(P.exclMarcas&&P.exclMarcas.length){
var sinExcl=items.filter(function(p){return !brandHit(p.title,P.exclMarcas)});
if(sinExcl.length){items=sinExcl}}
scoreItems(items);
lastAll=items;
var fp=filterProfile(items);
var pool=fp.pool,fuera=false;
if(P.budget){
var dentro=pool.filter(function(p){return p.__pr>0&&p.__pr<=P.budget});
if(dentro.length){pool=dentro}
else{fuera=true;pool=pool.slice().sort(function(a,b){return a.__pr-b.__pr}).slice(0,MAXP)}
}
if(P.cheap){pool=pool.slice().sort(function(a,b){return a.__pr-b.__pr})}
else{var med0=median(pool.map(function(p){return p.__pr}));
pool=pool.slice().sort(function(a,b){return b.__s-a.__s||Math.abs(a.__pr-med0)-Math.abs(b.__pr-med0)})}
var nota=fp.notes.length?('No me quedan muchos exactos '+esc(fp.notes.join(' y '))+' — esto es lo más cercano que traigo:'):'';
var head0;
if(fuera){var min=pool[0]?pool[0].__pr:0;head0='Con tu presupuesto de <b>$'+fmt(P.budget)+'</b> no atrapé ninguno disponible — pero por <b>$'+fmt(Math.max(min-P.budget,1))+' más</b> te llevas esto, y te dura temporadas:'}
else if(nota){head0=(pre?pre+'<br>':'')+nota}
else{head0=(pre?pre+'<br>':'')+(intro||ctxLine())}
/* v7.0 SPIKES: antes de pintar, se comprueba que la VARIANTE de su numero exista y este
   disponible. Lo que no tenga su talla NO se muestra como si la tuviera. */
if(P.cat==='spikes'&&P.talla){
var poolT=pool.slice(0,10);
filtraPorTalla(poolT,P.talla,function(){
var conTalla=poolT.filter(function(p){return p.__tallaOk});
var sinTalla=poolT.filter(function(p){return !p.__tallaOk});
if(!conTalla.length){
/* NADA en su talla: no lo dejamos en el aire */
state.miss++;saveState();
push('bot','Te la voy a dar derecho: <b>en tu '+tallaTxt(P.talla)+' no me queda nada de estos ahorita</b>. Dos salidas:<br>1) Déjame tus datos y <b>te aviso en cuanto entre tu número</b>.<br>2) El equipo te lo busca al momento y te lo consigue:<br>'+waBtn('Hola, busco '+(SUELA_CORTA[P.suela]||'spikes')+' en talla '+tallaTxt(P.talla)+' — ¿qué tienen?','Que me lo busquen'),'bmc-wide');
if(sinTalla.length){
reasonsFor(sinTalla.slice(0,MAXP));
push('bot','Y por si te sirve de referencia, estos son los modelos — <b>ojo: NO en tu talla</b>:'+prodCards(sinTalla.slice(0,MAXP)),'bmc-wide');
setLast(sinTalla)}
leadTrasValor('talla');
return}
var mostrar=conTalla.slice(0,MAXP);
var h=head0;
if(conTalla.length<MINP){
h+='<br>Te lo digo como es: <b>en tu '+tallaTxt(P.talla)+' tengo estos '+conTalla.length+' ahorita</b>. Si quieres te aviso en cuanto entren más, o te los busco por WhatsApp.';
if(sinTalla.length){mostrar=conTalla.concat([]);}
}
reasonsFor(mostrar);
state.miss=0;
push('bot',h+prodCards(mostrar),'bmc-wide');
setLast(mostrar);
if(conTalla.length<MINP&&sinTalla.length){
push('bot','Estos otros me gustan para ti pero <b>no los tengo en tu '+tallaTxt(P.talla)+'</b> — te los dejo por si te animas a otro número:'+prodCards(sinTalla.slice(0,2)),'bmc-wide')}
if(conTalla.length<MINP){leadTrasValor('talla')}
advanceQ(mostrar);
});
return}
pool=pool.slice(0,MAXP);
reasonsFor(pool);
state.miss=0;
push('bot',head0+prodCards(pool),'bmc-wide');
setLast(pool);
advanceQ(pool);
}
function searchProducts(qBase,intro){
var P=state.perfil,q=qBase;
lastQBase=qBase;
if(P.marca&&norm(qBase).indexOf(P.marca)===-1){q=qBase+' '+P.marca}
typing(function(){
suggest(q,10,function(items){
if(items===null){push('bot','Se me cayó la señal un segundo. Inténtalo de nuevo o escríbenos por WhatsApp:<br>'+waBtn('Hola, necesito ayuda con un producto'));return}
if(!items.length&&q!==qBase){
suggest(qBase,10,function(items2){
if(!items2||!items2.length){noResults(qBase,intro);return}
enrichTags(items2,function(){renderResults(items2,qBase,intro,'De <b>'+esc(cap(P.marca))+'</b> no tengo justo eso ahorita, pero mira estas opciones igual de buenas:')})
});return}
if(!items.length){noResults(qBase,intro);return}
enrichTags(items,function(){renderResults(items,q,intro,'')})
})
})}
/* ---------- Afinar por precio / marca (el cierre ya no cae al vacío) ---------- */
/* v7.0: TODO refinamiento (mas barato, tope de gama, rango de precio, marca, otras marcas)
   arranca de aqui — y aqui el CANDADO DE DEPORTE se vuelve a aplicar, DURO. Asi el deporte
   nunca se pierde al refinar, que es exactamente lo que fallaba. */
function profBase(){
if(!lastAll.length){return []}
var base=deporteLock(lastAll);
/* si el candado deja el pool vacio devolvemos vacio A PROPOSITO: quien llama vuelve a
   buscar con la query correcta en vez de mostrar el deporte equivocado. */
if(!base.length){return []}
return filterProfile(base).pool}
function showPriceChips(){
push('bot','<div class=bmc-chips>'+[['0','500','Hasta $500'],['500','1500','$500 a $1,500'],['1500','3000','$1,500 a $3,000'],['3000','','$3,000 en adelante']].map(function(r){return '<button type=button data-pmin="'+r[0]+'" data-pmax="'+r[1]+'">'+r[2]+'</button>'}).join('')+'</div>','bmc-bare');
state.await='afinar';saveState()}
function showBrandChips(){
var bs=(state.last&&state.last.brands&&state.last.brands.length)?state.last.brands:brandsIn(lastAll);
if(!bs.length){botSay('En estos resultados no traigo marcas que te pueda separar — dime la marca que te late (Rawlings, Wilson, Easton...) y te la busco.');return}
push('bot','<div class=bmc-chips>'+bs.map(function(b){return '<button type=button data-bmarca="'+esc(b)+'">'+esc(cap(b))+'</button>'}).join('')+'</div>','bmc-bare');
state.await='afinar';saveState()}
function pickRango(min,max){
var base=profBase();
if(!base.length){
if(state.last&&state.last.qBase){if(max){setP('budget',max)}searchProducts(state.last.qBase)}
else{botSay('Dime qué producto buscas y te lo filtro por ese precio.')}
return}
var pool=base.filter(function(p){return p.__pr>=min&&(max?p.__pr<=max:true)});
var head='En ese rango, esto es lo que traigo:';
if(pool.length<MINP){
head='Justo en ese rango tengo poquito — te acerco lo más parecido en precio:';
pool=base.slice().sort(function(a,b){
function dist(p){return p.__pr<min?min-p.__pr:(max&&p.__pr>max?p.__pr-max:0)}
return dist(a)-dist(b)}).slice(0,MAXP)}
renderPool(pool,head,base)}
function pickMarca(b){
setP('marca',b);
var base=profBase();
if(!base.length){if(state.last&&state.last.qBase){searchProducts(state.last.qBase)}return}
var re=brandRe(b);
var pool=base.filter(function(p){return re&&re.test(norm(p.title))});
if(pool.length){renderPool(pool,'Puro '+esc(cap(b))+', va:',base)}
else if(state.last&&state.last.qBase){searchProducts(state.last.qBase)}}
function refinePrecio(dir){
var L=state.last;
var base=profBase();
if(!base.length){
if(L&&L.qBase){if(dir==='abajo'){setP('cheap',1)}searchProducts(L.qBase)}
return}
var med=(L&&L.med)||median(base.map(function(p){return p.__pr}));
var pool=base.filter(function(p){return dir==='abajo'?(p.__pr>0&&p.__pr<med):(p.__pr>med)});
var head;
if(dir==='abajo'){
pool.sort(function(a,b){return a.__pr-b.__pr});
head='Va, cuidando el bolsillo — de lo que tengo, lo más accesible:';
if(pool.length<MINP){head='Va, cuidando el bolsillo — estos son los de mejor precio que traigo:';pool=base.slice().sort(function(a,b){return a.__pr-b.__pr}).slice(0,MAXP)}
}else{
pool.sort(function(a,b){return b.__pr-a.__pr});
head='Va con lo mejorcito — calidad de arriba:';
if(pool.length<MINP){head='Va con lo mejorcito — estos son los tope de gama que traigo:';pool=base.slice().sort(function(a,b){return b.__pr-a.__pr}).slice(0,MAXP)}
}
renderPool(pool,head,base)}
function excludeBrand(b){
var P=state.perfil,ex=P.exclMarcas||[];
if(ex.indexOf(b)<0){ex.push(b)}
setP('exclMarcas',ex);
if(P.marca===b){delete P.marca;saveState()}
var baseX=profBase();
var pool=baseX.filter(function(p){return !brandHit(p.title,ex)});
if(pool.length){renderPool(pool,'Va, sin '+esc(cap(b))+' — mira estas opciones:',baseX)}
else if(state.last&&state.last.qBase){botSay('Sin esa marca me quedo corto con lo que te mostré — déjame buscar más amplio:',function(){searchProducts(state.last.qBase)})}
else{botSay('Anotado: nada de '+esc(cap(b))+'. ¿Qué buscamos?',chips)}}
function excludeShownBrands(){
var L=state.last,bs=(L&&L.brands&&L.brands.length)?L.brands:brandsIn(lastAll);
if(!bs.length){botSay('Dime qué marca no te late y la saco de la búsqueda.');return}
var P=state.perfil,ex=P.exclMarcas||[];
bs.forEach(function(b){if(ex.indexOf(b)<0){ex.push(b)}});
setP('exclMarcas',ex);
if(P.marca&&ex.indexOf(P.marca)>-1){delete P.marca;saveState()}
var baseB=profBase();
var pool=baseB.filter(function(p){return !brandHit(p.title,ex)});
if(pool.length){renderPool(pool,'Va, otras marcas — mira estas:',baseB)}
else if(L&&L.qBase){botSay('Va — déjame ampliar la red sin esas marcas:',function(){searchProducts(L.qBase)})}
else{botSay('De otras marcas en esto me quedo corto en línea, pero el equipo te consigue más por WhatsApp:<br>'+waBtn('Hola, busco '+((L&&L.qBase)||'equipo')+' de otras marcas'))}}
/* ---------- CORRECCIONES: el cliente reclama y el bot corrige, no se hace el loco ---------- */
/* v6: al corregir material, la BÚSQUEDA también cambia de material (no solo el filtro) */
/* v7.0: la query de refinamiento CONSERVA el deporte. Antes se reconstruia solo con
   categoria + material y por ahi se colaba el deporte contrario. */
function qMaterial(mat){
var qb=(state.last&&state.last.qBase)||'';
qb=qb.replace(/(aluminio|alloy|compuesto|composite|mader\w*|maple|bamb\w*|birch|abedul)/g,'').replace(/\s+/g,' ').trim();
if(!qb){qb=(state.last&&state.last.cat)||'bat'}
var q=qb+' '+mat;
var P=state.perfil;
if(P.deporte==='softbol'&&norm(q).indexOf('softbol')===-1){q+=' softbol'}
return q}
/* ---------- v7.0 REGLA DE NEGOCIO: EN SOFTBOL NO HAY BATS DE MADERA ----------
   Karina, literal: "en softbol NO manejamos bats de madera, no hay bate de madera en
   softball". Verificado contra el catalogo el 7-ago-2026: los 33 productos con product type
   "Bat Softball" / "Bat Softball Infantil" son 100% aluminio o compuesto.
   Si el cliente pide madera para softbol NO se le dice "no hay" a secas: se le explica
   como vendedor y se le ofrecen las opciones que si existen. */
function maderaEnSoftbol(){
delete state.perfil.material;saveState();
botSay('Ahí sí te paro tantito, con confianza: <b>en softbol no se juega con madera</b> — el bat de softbol va de <b>aluminio</b> o de <b>compuesto</b>. La madera es cosa de béisbol (ahí sí tengo un montón).<br>Para tu softbol, ¿cómo le entramos?',function(){
push('bot',chipsHtml('materialSb',STEPS.materialSb.ops),'bmc-bare');
state.flow='bat';state.await='';saveState()});
return true}
function corrections(n){
if(!state.last){return false}
if(catRule(n)&&!/(eso|esto|este|ese)s?\s+(son|es)/.test(n)){return false}
if(/((eso|esto|este|ese)s?\s+(son|es)\s+de\s+(metal|aluminio))|no\s+(son|es)\s+de\s+madera|quiero\s+(un[oa]s?\s+)?de\s+madera|los?\s+quiero\s+de\s+madera|(^|\s)de\s+madera(\s|$)/.test(n)){
if(state.perfil.deporte==='softbol'&&(state.perfil.cat==='bat'||state.last.cat==='bat')){return maderaEnSoftbol()}
setP('material','madera');
noteFail('bat de madera'); /* corrección = strike del bot; al 2º, WhatsApp proactivo */
botSay('Tienes toda la razón — esa fue una mala atrapada mía. Va de nuevo, ahora sí puro de madera:',function(){searchProducts(qMaterial('madera'))});
return true}
if(/((eso|esto|este|ese)s?\s+(son|es)\s+de\s+madera)|quiero\s+(un[oa]s?\s+)?de\s+(metal|aluminio)/.test(n)){
setP('material','aluminio');
noteFail('bat de aluminio');
botSay('Va, corregido — te muestro de aluminio:',function(){searchProducts(qMaterial('aluminio'))});
return true}
/* v7.0: CORRECCION DE DEPORTE a media conversacion — "es de softbol", "no, de beisbol".
   Cambia el candado y REBUSCA con la query del deporte correcto (no filtra lo que ya trajo). */
if(/(es|son|era|eran)\s+(de\s+|para\s+)?(softbol|softball|fastpitch)|(^|\s)(de|para)\s+(softbol|softball|fastpitch)(\s|$)|mejor\s+(de\s+)?softbol/.test(n)){
if(state.perfil.deporte!=='softbol'){
setP('deporte','softbol');
if(state.perfil.material==='madera'&&(state.perfil.cat==='bat')){return maderaEnSoftbol()}
noteFail('softbol');
botSay('¡Ah, softbol! Va, corrijo — eso cambia el equipo. Ahora sí, puro softbol:',function(){searchProducts(qDeporte())});
return true}}
if(/(es|son|era|eran)\s+(de\s+|para\s+)?(beisbol|baseball)|(^|\s)(de|para)\s+(beisbol|baseball)(\s|$)/.test(n)){
if(state.perfil.deporte!=='beisbol'){
setP('deporte','beisbol');
botSay('Va, corrijo — de <b>béisbol</b> entonces:',function(){searchProducts(qDeporte())});
return true}}
/* v7.0: CAMBIO DE MATERIAL suelto ("mejor de aluminio", "de compuesto", "que sea de madera").
   Antes esto se iba de largo a searchProducts con el texto crudo y caia en "no tengo en
   linea". Ahora se trata como refinamiento: cambia el material, CONSERVA deporte y
   categoria, y vuelve a buscar. */
if(/(^|\s)(mejor\s+|que\s+sea\s+|quiero\s+|prefiero\s+|uno\s+|unos\s+)?de\s+(aluminio|alloy|compuesto|composite|madera|maple)(\s|$|[.,!?])/.test(n)&&n.length<45){
var matN=/(aluminio|alloy)/.test(n)?'aluminio':(/(compuesto|composite)/.test(n)?'compuesto':'madera');
if(matN==='madera'&&state.perfil.deporte==='softbol'&&(state.perfil.cat==='bat'||state.last.cat==='bat')){return maderaEnSoftbol()}
setP('material',matN);
botSay('Va, de <b>'+matN+'</b> entonces:',function(){searchProducts(qMaterial(matN))});
return true}
/* v7.0: correccion de suela en spikes sin perder deporte ni talla */
if(state.perfil.cat==='spikes'&&/(de\s+)?(metal|metalicos)/.test(n)&&n.length<40){setP('suela','metal');botSay('Va, de <b>metal</b>:',function(){recSpikes()});return true}
if(state.perfil.cat==='spikes'&&/(de\s+)?(plastico|molded|tpu)/.test(n)&&n.length<40){setP('suela','plastico');botSay('Va, de <b>plástico</b>:',function(){recSpikes()});return true}
if(/(mas\s+)?(barat|economic)/.test(n)&&n.length<40){refinePrecio('abajo');return true}
if(/(mas\s+car[oa]|mejor\s+calidad|mas\s+calidad|premium|algo\s+mejor|de\s+mas\s+calidad)/.test(n)){refinePrecio('arriba');return true}
if(/otra(s)?\s+marca(s)?/.test(n)){excludeShownBrands();return true}
if(/(no\s+me\s+gusta|no\s+quiero|que\s+no\s+sea|(^|\s)sin\s|(^|\s)menos\s)/.test(n)){
for(var i=0;i<BRANDS.length;i++){if(BRANDS[i][1].test(n)){excludeBrand(BRANDS[i][0]);return true}}}
if(/(en|para)\s+zurd|(^|\s)zurd[oa]s?\s*\??$/.test(n)){
if(state.last.cat==='bat'){
botSay('Buena noticia: los bats no vienen en zurdo o diestro — el mismo bat sirve para ambos lados del plato. Donde sí cambia es en los guantes: ahí se pide versión LHT. ¿Te muestro guantes para zurdo?');
state.await='zurdoGuante';saveState();
return true}
setP('mano','LHT');
botSay('Va, en zurdo:',function(){searchProducts(state.last.qBase||buildQuery(state.perfil.cat||'guante'))});
return true}
return false}
/* ---------- Seguimiento tras "Ver producto" (venta cruzada útil) ---------- */
function followUpViewed(){
var v=state.viewed;
if(!v||v.asked||!v.t){return}
v.asked=1;saveState();
botSay('Oye, ¿qué tal viste <b>'+esc(v.t)+'</b>? Si te quedó, dale <b>Agregar al carrito</b> en su tarjeta de arriba — o dime y afinamos por talla, precio o marca.',function(){crossSell(v.t)})}
/* ---------- v6 ESCALACIÓN ANTI-LOOP: 2 strikes y ofrecemos WhatsApp con contexto, sin que lo pidan ---------- */
function waCtx(extra){
var pt=perfilTexto();
var ult=conv.filter(function(m){return m.w==='user'}).slice(-3).map(function(m){return plain(m.h)}).join(' / ');
return 'Hola, vengo del chat de beisbolmania.mx y necesito ayuda. Busco: '+(extra||ult||'ayuda con mi compra')+(pt?' ('+pt+')':'')}
function noteFail(t){
state.fail=(state.fail||0)+1;saveState();
if(state.fail>=2){state.fail=0;saveState();
setTimeout(function(){enqueueTurn(function(){push('bot','Y para no hacerte dar vueltas: si prefieres, el equipo te lo resuelve al momento por WhatsApp — el mensaje ya va con el contexto de lo que buscas.<br>'+waBtn(waCtx(t),'Resolver por WhatsApp'))})},2600)}}
function fallback(t){
state.miss++;saveState();
if(state.miss<2){noteFail(t);botSay('No te caché bien esa. Dime qué producto buscas ("guante rawlings", "bat de madera para 12 años") o escoge una opción:',chips)}
else{state.miss=0;state.fail=0;saveState();
botSay('Esa me la anoto para el equipo — te la resuelven al momento por WhatsApp (tu mensaje ya va con el contexto):<br>'+waBtn(waCtx(t)),chips)}}
/* ---------- v6 WISMO: "¿dónde está mi pedido?" — Fase 1 sin backend, 3 rutas ----------
   TODO(FASE2): endpoint en el servidor (159.203.176.241) que consulte la orden en Shopify
   por numero+correo y responda aquí mismo el estatus + guía, sin sacar al cliente del chat. */
function wismoWa(nombre,numero){
var num=String(numero||'').trim();
if(num&&num.charAt(0)!=='#'&&/^\d/.test(num)){num='#'+num}
return waLink('Hola, soy '+String(nombre||'').trim()+', quiero rastrear mi pedido '+num)}
function wismo(){
state.await='';state.flow='';state.miss=0;saveState();
botSay('¡Claro! Tu paquete no se nos pierde. Tienes 3 rutas — usa la que te quede más a la mano:',function(){
push('bot','<div class=bmc-routes>'
+'<div class=bmc-route><div class=bmc-route-t>Tu correo de confirmación</div><div class=bmc-route-d>Busca el correo <b>"Pedido confirmado"</b> que te llegó al comprar: trae un botón que abre la página de estado de tu pedido con el <b>rastreo en vivo</b> de la paquetería.</div></div>'
+'<div class=bmc-route><div class=bmc-route-t>Tu cuenta</div><div class=bmc-route-d>Entra con tu correo — te llega un <b>código de acceso</b> (sin contraseña) — y ahí ves el estado de todos tus pedidos.</div><a class=bmc-route-a href="/account">Entrar a mi cuenta &rarr;</a></div>'
+'<div class=bmc-route><div class=bmc-route-t>Te lo rastreamos por WhatsApp</div><div class=bmc-route-d>Pásame tu nombre y tu <b>número de pedido</b> (viene en tu correo, ej. #1234) y el equipo te dice al momento dónde va.</div>'
+'<form class=bmc-wismo><input name=nombre type=text placeholder="Tu nombre" required aria-label="Tu nombre"><input name=numero type=text placeholder="Número de pedido (#1234)" required aria-label="Número de pedido"><button type=submit>Rastrear por WhatsApp</button></form></div>'
+'</div>','bmc-wide');
nextChips();
})}
function intent(a){
if(a==='talla'){botSay('Cada producto tiene su botón <b>Encuéntrala aquí</b> en su misma página, con la guía exacta de medidas. ¿Te abro una categoría para que escojas tu equipo?',chips);return}
if(a==='wismo'){wismo();return}
if(a==='menu'){chips();return}
if(a==='menu1'){chips(1);return}
if(a==='menu2'){chips(2);return}
if(a==='menu3'){chips(3);return}
/* v7.0 Karina: cada vez que se habla de la tienda, ademas del texto va el boton de Maps */
if(a==='tienda'){botSay(tiendaHtml('Nos encuentras en <b>'+TIENDA_DIR+'</b> — '+TIENDA_HOR+'. ¡Pásale a probarte el guante en persona!'),function(){leadMarcaValor();chips()});return}
if(a==='recoger'){botSay(tiendaHtml('¡Claro! Puedes <b>recoger en tienda</b>: estamos en <b>'+TIENDA_DIR+'</b>, '+TIENDA_HOR+'. Antes de venir, escríbenos y te apartamos la pieza para que no hagas el viaje en balde.'),function(){leadTrasValor('stock');chips()});return}
if(a==='humano'){askLead(LEAD_COPY.ayuda,'humano');return}
if(a==='personalizado'){askLead('¡Claro que sí! Hacemos <b>jerseys bordados, bats grabados y equipo personalizado</b> — se cotiza por WhatsApp. Déjame tus datos o escríbenos directo.','personalizado');return}
if(a==='objecion'){botSay('Te entiendo, pero mira lo que juega a tu favor:<br><b>Garantía de 30 días</b> — si algo sale con detalle, lo cambiamos sin drama.<br><b>A partir de 3 meses sin intereses</b> pagando con tarjeta en el checkout (compras desde '+money(MSI_MIN)+').<br>Y tenemos <b>tienda física en '+TIENDA_DIR+'</b>: lo que compras es de verdad.<br>'+mapsBtn('Cómo llegar')+'<br>Si quieres, te lo <b>apartamos por WhatsApp</b> mientras lo decides:<br>'+waBtn('Hola, quiero apartar un producto que vi en beisbolmania.mx','Apartar por WhatsApp'),function(){leadTrasValor('carrito')});return}
fallback('')}
/* v6 WISMO: prioridad máxima — pedido/orden/envío/dónde está/rastrear/guía/paquete */
function isWismo(n){
if(/(talla|medida)/.test(n)){return false}
if(/(rastre|seguimiento|track(ing)?\b|estatus|status)/.test(n)){return true}
if(/(^|\s)guia(\s|$|[.,!?])/.test(n)&&!/(generar|comprar)/.test(n)){return true}
if(/(pedido|orden|paquete|envio|compra)/.test(n)&&/(donde|mi |no (me )?(ha )?llega|cuando llega|ya (llego|salio|viene)|estado)/.test(n)){return true}
if(/^#?\s*(mi )?(pedido|orden)[\s?!.]*$/.test(n)){return true}
return false}
function route(t){
var n=norm(t);
/* v7.0 SPIKES: el cliente esta dictando su numero */
if(state.await==='talla'){
var tv=normTalla(t);
if(tv){state.await='';saveState();setP('talla',tv);tallaPerfilSetPie(tv);
botSay('Anotado: <b>'+tallaTxt(tv)+'</b>. Te la guardo para la próxima.',function(){
if(state.flow==='spikes'){nextStep()}else{recSpikes()}});
return}
state.await='';saveState();
}
if(state.await==='zurdoGuante'){
state.await='';saveState();
if(/^(si|s|va|dale|claro|orale|ok|okey|sale|simon|por favor|andale)\b/.test(n)&&n.length<20){setP('mano','LHT');setP('cat','guante');searchProducts('guante');return}
}
if(state.await==='afinar'){
var af=n.replace(/[^a-z0-9 ]/g,'').trim();
if(/^(si|va|dale|ok|okey|claro|sale|simon)$/.test(af)){botSay('¿Por cuál le entramos?',function(){push('bot','<div class=bmc-chips><button type=button data-af=precio>Por precio</button><button type=button data-af=marca>Por marca</button></div>','bmc-bare')});return}
if(/^(por )?precio$/.test(af)||/afinar.*precio/.test(af)){botSay('Va, ¿en qué rango andas?',showPriceChips);return}
if(/^(por )?marca$/.test(af)||/^(por )?marcas$/.test(af)){botSay('Estas son las marcas de lo que te mostré:',showBrandChips);return}
if(/^\$?\s*\d[\d,]{2,}\s*(pesos|mxn)?$/.test(af.replace(/\s+/g,' '))&&lastAll.length){sniffCompra(n);var bb=state.perfil.budget;if(bb){pickRango(0,bb);return}}
state.await='';saveState();
}
if(/(^|\s)(hola|buenas|buen dia|buenos dias|buenas tardes|buenas noches|que onda|hey)(\s|$|!|,)/.test(n)&&n.length<25){botSay('¡Hola! ¿Qué andas buscando hoy? Escoge una opción o escríbeme qué necesitas.',chips);return}
if(/(gracias|perfecto|va que va|de lujo)/.test(n)&&n.length<30){state.fail=0;saveState();botSay('¡Con gusto! Aquí sigo atrapando dudas por si necesitas algo más.',chips);return}
if(isWismo(n)){wismo();return}
if(corrections(n)){return}
if(/(esta caro|muy caro|carisimo|esta carito|lo pienso|lo voy a pensar|dejame pensarlo|lo consulto|al rato vengo|luego regreso|no estoy segur|no me convence|mejor despues|es mucho dinero|no me alcanza)/.test(n)){intent('objecion');return}
if(/(humano|asesor|agente|persona real|con alguien|atencion a clientes|cotiza)/.test(n)){intent('humano');return}
if(/(personaliz|bordad|grabad|jersey|uniforme)/.test(n)){intent('personalizado');return}
if(/(garantia|defecto|devoluc|reembolso|cambiar(lo|la)? )/.test(n)){botSay('Todos nuestros productos tienen <b>garantía de 30 días</b>. Si algo sale con detalle, lo cambiamos sin drama. ¿Te ayudo con algo más?',function(){leadTrasValor('suave')});return}
/* v7.0: envio y disponibilidad son "momento natural" para el 2o intento del lead */
if(/(envio|enviar|paqueteria|cuanto tarda|cuando llega|envios)/.test(n)&&!/(mi pedido|rastre|orden)/.test(n)){botSay('El envío es <b>GRATIS en compras desde $2,000 MXN</b>. Si tu compra es menor, el costo se cotiza al finalizar tu pedido según tu dirección. ¿Algo más?',function(){leadTrasValor('envio')});return}
if(/(msi|meses sin|mensualidad|a meses|tarjeta|credito)/.test(n)){botSay('¡Claro! Manejamos <b>meses sin intereses a partir de 3 meses</b> en compras desde '+money(MSI_MIN)+', pagando con tarjeta directo en el checkout. Agrega tu equipo al carrito y elige la opción al pagar.',function(){leadTrasValor('suave')});return}
if(/factur/.test(n)){botSay('Sí facturamos. Mándanos tus datos fiscales y tu número de orden por WhatsApp o a <b>info@beisbolmania.mx</b> y te la enviamos.<br>'+waBtn('Hola, necesito factura de mi compra'),function(){leadMarcaValor()});return}
/* v7.0: "recoger en tienda" tambien pinta el boton de Google Maps */
if(/(recoger en tienda|recojo en tienda|paso por el|puedo pasar|pickup|pick up|recolecci|voy por el|lo recojo)/.test(n)){intent('recoger');return}
if(/(tienda fisica|sucursal|direccion|donde estan|donde se ubican|donde se encuentran|ubicacion|como llego|donde queda|local|visitarlos|mapa|maps|horario)/.test(n)){intent('tienda');return}
if(/(mi pedido|mi orden|mi paquete|entrega de mi)/.test(n)){wismo();return}
if(/(talla|medida|size|que numero soy)/.test(n)&&!/(guante|manopla|bat|spike|kit|catcher|calzo|numero calzo)/.test(n)){intent('talla');return}
if(/(agotado|sin stock|no hay|apartar|cuando llega el)/.test(n)){askLead(LEAD_COPY.stock,'stock');return}
/* Venta con parser: lee edad/mano/posición/material + marca/presupuesto/deporte y decide */
sniffPerfil(n);sniffCompra(n);
var c=catRule(n);
if(c){
if(c.cat){setP('cat',c.cat)}
/* v6 anti-asumir: cascos SIEMPRE pasan por el flujo (que solo pregunta lo que falta) */
if(c.f==='casco'){startFlow('casco');return}
if(c.f&&!(state.perfil.marca||state.perfil.budget||state.perfil.cheap)){startFlow(c.f);return}
if(c.f){state.flow='';state.miss=0;saveState();FLOWS[c.f].done();return}
searchProducts(buildQuery(c.q),c.i);return}
/* "no sé" a media pregunta: opción segura + guía (jamás otra pregunta) */
if(state.flow&&/^(no ?se|nose|ni idea|no estoy segur|no tengo idea|npi)/.test(n.replace(/[^a-z ]/g,'').trim())){flowNoSe();return}
/* Si estamos a media pregunta y escribió en vez de picar chip, el sniff pudo llenar el dato: sigue el flujo */
if(state.flow){nextStep();return}
if(n.replace(/[^a-z0-9 ]/g,'').trim().length>=3){searchProducts(t);return}
fallback(t)}
function pickCat(c){if(!c){return}push('user',esc(c.l));state.inter++;saveState();enqueueTurn(function(){if(c.c){setP('cat',c.c)}if(c.f){startFlow(c.f)}else if(c.q){searchProducts(buildQuery(c.q))}else{intent(c.a)}})}
function userSays(t){
if(bloqueado()){candadoNudge();return}
push('user',esc(t));state.inter++;saveState();
enqueueTurn(function(){route(t)});
/* v7.0 RED DE SEGURIDAD DEL LEAD: si ya le dimos valor y lleva 3+ mensajes sin que se lo
   hayamos pedido, se pide aqui. Con sus propios candados (tope 2, espera de 90 s, jamas si
   ya lo dio), asi que no se le encima a la peticion que ya hizo advanceQ. */
setTimeout(function(){enqueueTurn(leadRedDeSeguridad)},2600)}
function openPanel(){open=true;panel.hidden=false;bubble.hidden=true;fab.setAttribute('aria-expanded','true');
if(!greeted){greeted=true;
/* v6.3 CANDADO: sin datos no hay chat — saludo + formulario obligatorio, sin saltar */
if(bloqueado()){
push('bot','¡Qué onda! Soy <b>EL CÁTCHER</b> de Beisbolmania — tu vendedor de confianza, al instante.');
push('bot',candadoFormHtml(),'bmc-bare');
state.leadAsked=true;state.leadCtx='candado';saveState();
}else{
/* v6.2: saludo INSTANTÁNEO (sin dots) — cero vacío blanco al abrir. El lead-lite entra
   a los 900ms POR LA COLA, así jamás se mete a media respuesta de otro turno. */
var saludo;
if(lead&&lead.n){saludo='¡Qué onda de nuevo, <b>'+esc(lead.n)+'</b>! Aquí EL CÁTCHER, listo. ¿Qué buscamos hoy?'}
else if(lead){saludo='¡Qué onda! Soy <b>EL CÁTCHER</b> de Beisbolmania. ¿Qué buscamos hoy?'}
else{saludo='¡Qué onda! Soy <b>EL CÁTCHER</b> de Beisbolmania. Dime qué buscas o escoge una ruta:'}
push('bot',saludo);chips();
/* v7.0: SE QUITA el lead-lite de los 900 ms al abrir. Regla Karina 7-ago: el lead se pide
   DESPUES de dar valor (tras mostrar productos o resolver la duda), NUNCA al abrir. De eso
   se encargan leadTrasValor() y leadRedDeSeguridad(), con tope de 2 por sesion. */
}
}
/* v6.3: sesión restaurada aún bloqueada (p.ej. historial de antes del candado): re-poner el formulario */
if(bloqueado()){
lockInput(true);
if(msgs&&!msgs.querySelector('.bmc-candado')){push('bot',candadoFormHtml(),'bmc-bare')}
}else{lockInput(false)}
if(state.viewed&&!state.viewed.asked&&(Date.now()-(state.viewed.at||0))<1800000&&conv.length){setTimeout(function(){enqueueTurn(followUpViewed)},1200)}
scrollDown();setTimeout(function(){if(input){input.focus()}},80)}
function close(){open=false;panel.hidden=true;panel.style.transform='';fab.setAttribute('aria-expanded','false');odooLogIfWorth()}
function toggle(){if(open){close()}else{openPanel()}}
function build(){
root=document.getElementById('bm-catcher');
if(!root||root.__built){return}
root.__built=true;
if(CFG.isProduct){root.classList.add('bmc-on-product')}
root.innerHTML='<div class=bmc-bubble hidden><button type=button class=bmc-bubble-x aria-label=Cerrar>×</button>'+esc(CFG.bubbleText||'¿Te ayudo a elegir?')+'</div>'
+'<button type=button class=bmc-fab aria-expanded=false aria-label="Abrir chat de ayuda EL CÁTCHER">'+mascotaImg('bmc-fab-img')+'</button>'
+'<div class=bmc-panel role=dialog aria-modal=true aria-label="EL CÁTCHER, asistente de Beisbolmania" hidden>'
+'<div class=bmc-handle aria-hidden=true><span></span></div>'
+'<div class=bmc-head><div class=bmc-head-ico>'+mascotaImg('bmc-head-img')+'</div><div class=bmc-head-tit><b>EL CÁTCHER</b><span><i class=bmc-dot></i>Beisbolmania · Respondemos al instante</span></div><button type=button class=bmc-close aria-label="Cerrar chat">×</button></div>'
+'<div class=bmc-msgs aria-live=polite></div>'
+'<form class=bmc-inputbar><input type=text autocomplete=off placeholder="Escribe aquí — ej. guante Rawlings" aria-label="Escribe tu mensaje"><button type=submit aria-label=Enviar>&rarr;</button></form>'
+'</div>';
fab=root.querySelector('.bmc-fab');
bubble=root.querySelector('.bmc-bubble');
panel=root.querySelector('.bmc-panel');
msgs=root.querySelector('.bmc-msgs');
input=root.querySelector('.bmc-inputbar input');
fab.addEventListener('click',toggle);
root.querySelector('.bmc-close').addEventListener('click',close);
root.querySelector('.bmc-bubble-x').addEventListener('click',function(e){e.stopPropagation();bubble.hidden=true;lsSet('bmcBubbleOff',1)});
bubble.addEventListener('click',openPanel);
root.querySelector('.bmc-inputbar').addEventListener('submit',function(e){e.preventDefault();var t=input.value.trim();if(!t){return}input.value='';userSays(t)});
/* v6.2: Enter directo en el input — no dependemos del submit nativo (temas con handlers globales lo bloqueaban) */
input.addEventListener('keydown',function(e){
if(e.key==='Enter'){e.preventDefault();e.stopPropagation();var t=input.value.trim();if(!t){return}input.value='';userSays(t)}
});
document.addEventListener('keydown',function(e){
if(!open){return}
if(e.key==='Escape'){close();fab.focus();return}
if(e.key==='Tab'){var f=panel.querySelectorAll('button,input,a[href]');if(!f.length){return}var first=f[0],last=f[f.length-1];if(e.shiftKey&&document.activeElement===first){e.preventDefault();last.focus()}else if(!e.shiftKey&&document.activeElement===last){e.preventDefault();first.focus()}}
});
/* v6 móvil: bottom sheet con asa de arrastre — drag-to-close */
var handle=root.querySelector('.bmc-handle');
if(handle){
var dragY=0,dY=0,dragging=false;
handle.addEventListener('touchstart',function(e){dragging=true;dY=0;dragY=e.touches[0].clientY;panel.style.transition='none'},{passive:true});
handle.addEventListener('touchmove',function(e){if(!dragging){return}dY=e.touches[0].clientY-dragY;if(dY>0){panel.style.transform='translateY('+dY+'px)'}},{passive:true});
handle.addEventListener('touchend',function(){if(!dragging){return}dragging=false;panel.style.transition='';panel.style.transform='';if(dY>90){close()}});
}
msgs.addEventListener('click',function(e){
/* v6.3 candado: chips y acciones bloqueadas hasta dar los datos (el form sí funciona) */
if(bloqueado()){
var accionable=e.target.closest('[data-chip],[data-act],[data-fk],[data-af],[data-pmin],[data-bmarca],button.bmc-add,[data-leadskip],a.bmc-card-view');
if(accionable){e.preventDefault();candadoNudge();return}
}
/* v6.2 anti doble clic: un grupo de chips solo dispara UNA vez */
var anyChip=e.target.closest('.bmc-chips button');
if(anyChip){
if(anyChip.disabled){return}
var grp=anyChip.closest('.bmc-chips');
if(grp){[].forEach.call(grp.querySelectorAll('button'),function(b){b.disabled=true})}
}
var skip=e.target.closest('[data-leadskip]');
if(skip){var fm=skip.closest('form');if(fm){fm.remove()}push('user','Ahora no');enqueueTurn(function(){botSay('¡Sin bronca! Cuando quieras me lo pasas. ¿Qué andas buscando hoy?',chips)});return}
var vw=e.target.closest('a[data-view]');
if(vw){state.viewed={t:vw.getAttribute('data-view')||'',at:Date.now()};saveState();setTimeout(function(){if(open&&state.viewed&&!state.viewed.asked){enqueueTurn(followUpViewed)}},30000)}
var fv=e.target.closest('[data-fk]');
if(fv){pickFlowChip(fv.getAttribute('data-fk'),fv.getAttribute('data-fv'),fv.textContent);return}
var chip=e.target.closest('[data-chip]');
if(chip){var mn=MENUS[parseInt(chip.getAttribute('data-m'),10)||0]||MENUS[0];pickCat(mn[parseInt(chip.getAttribute('data-chip'),10)]);return}
var act=e.target.closest('[data-act]');
if(act){push('user',esc(act.textContent));state.inter++;saveState();var actA=act.getAttribute('data-act');enqueueTurn(function(){intent(actA)});return}
var afb=e.target.closest('[data-af]');
if(afb){push('user',esc(afb.textContent));state.inter++;saveState();var afV=afb.getAttribute('data-af');enqueueTurn(function(){if(afV==='precio'){botSay('Va, ¿en qué rango andas?',showPriceChips)}else{botSay('Estas son las marcas de lo que te mostré:',showBrandChips)}});return}
var prb=e.target.closest('[data-pmin]');
if(prb){push('user',esc(prb.textContent));state.inter++;saveState();var pMin=parseFloat(prb.getAttribute('data-pmin'))||0,pMax=parseFloat(prb.getAttribute('data-pmax'))||0;enqueueTurn(function(){pickRango(pMin,pMax)});return}
var bmb=e.target.closest('[data-bmarca]');
if(bmb){push('user',esc(bmb.textContent));state.inter++;saveState();var bV=bmb.getAttribute('data-bmarca');enqueueTurn(function(){pickMarca(bV)});return}
var add=e.target.closest('button.bmc-add');
if(add){addToCart(add);return}
var seguir=e.target.closest('[data-seguir]');
if(seguir){e.preventDefault();botSay('¡Ese es el espíritu! ¿Qué más buscamos?',chips);return}
if(e.target.closest('[data-leadwa]')&&!lead){lsSet('bmcLead',{via:'whatsapp',at:Date.now()});lead=lsGet('bmcLead')}
});
msgs.addEventListener('submit',function(e){
var fw=e.target.closest('.bmc-wismo');
if(fw){
e.preventDefault();
var wn=fw.querySelector('[name=nombre]').value.trim();
var wo=fw.querySelector('[name=numero]').value.trim();
if(!wn||!wo){return}
/* TODO(FASE2): en lugar de abrir WhatsApp, pegarle al endpoint del servidor y responder aquí el estatus */
var wurl=wismoWa(wn,wo);
try{window.open(wurl,'_blank','noopener')}catch(err){}
push('user','Rastrear pedido '+esc(wo));
enqueueTurn(function(){botSay('¡Va, <b>'+esc(wn)+'</b>! Te abrí WhatsApp con tu mensaje listo — solo dale enviar y el equipo te dice al momento dónde va tu pedido. Si no se abrió, dale aquí:<br><a class=bmc-wabtn target=_blank rel=noopener href="'+esc(wurl)+'">Rastrear por WhatsApp</a>',function(){nextChips()})});
odooLogIfWorth();
return}
var f=e.target.closest('.bmc-lead');
if(!f){return}
e.preventDefault();
var n=f.querySelector('[name=nombre]').value.trim();
var c=f.querySelector('[name=contacto]').value.trim();
if(!n){leadError(f,'¿Cómo te llamas? Con tu nombre arrancamos.');return}
if(!c){leadError(f,'Déjame tu WhatsApp (10 dígitos) o tu correo.');return}
var vc=validaContacto(c);
if(!vc.ok){leadError(f,vc.msg);return} /* error claro SIN perder lo tecleado */
var er=f.querySelector('.bmc-lead-err');if(er){er.remove()}
f.querySelector('button').disabled=true;
sendLead(n,vc.v,f)
});
window.addEventListener('pagehide',function(){odooLogIfWorth()});
conv.forEach(function(m){paint(m.w,m.h,m.c,m.ts)});
/* v6.3: ya desbloqueado, el formulario de candado del historial restaurado se quita (evita re-envíos) */
if(!bloqueado()){[].forEach.call(msgs.querySelectorAll('.bmc-candado-box'),function(bx){var m=bx.closest('.bmc-msg');if(m){m.remove()}})}
if(!lsGet('bmcBubbleOff')){setTimeout(function(){if(!open&&bubble){bubble.hidden=false}},5000)}
}
if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',build)}else{build()}
/* hook de prueba: inerte en producción (window.__bmcTest no existe en la tienda) */
if(typeof window.__bmcTest==='function'){window.__bmcTest({norm:norm,bloqueado:bloqueado,validaContacto:validaContacto,candadoFormHtml:candadoFormHtml,lockInput:lockInput,enqueueTurn:enqueueTurn,turnState:function(){return{busy:turnBusy,q:turnQ.length,pendT:pendT,netPend:netPend}},typePass:typePass,typeOf:typeOf,TYPERULES:TYPERULES,suggest:suggest,sniffPerfil:sniffPerfil,sniffCompra:sniffCompra,catRule:catRule,buildQuery:buildQuery,scoreItems:scoreItems,reasonsFor:reasonsFor,priceNum:priceNum,ctxLine:ctxLine,segTxt:segTxt,state:state,FLOWS:FLOWS,filterProfile:filterProfile,dimPass:dimPass,median:median,corrections:corrections,brandsIn:brandsIn,klaviyoLead:klaviyoLead,userSays:userSays,route:route,pickFlowChip:pickFlowChip,searchProducts:searchProducts,sendLead:sendLead,pickRango:pickRango,pickMarca:pickMarca,refinePrecio:refinePrecio,conv:conv,isWismo:isWismo,wismo:wismo,wismoWa:wismoWa,recCasco:recCasco,specFor:specFor,SAFE:SAFE,flowNoSe:flowNoSe,noteFail:noteFail,MENUS:MENUS,openPanel:openPanel,pickCat:pickCat,pendingStep:pendingStep,
/* v7.0 */
deporteLock:deporteLock,esSoftbol:esSoftbol,esBeisbolPuro:esBeisbolPuro,qDeporte:qDeporte,
TOPVENTAS:TOPVENTAS,TOPVENTAS_AL:TOPVENTAS_AL,topRank:topRank,MINP:MINP,MAXP:MAXP,
normTalla:normTalla,tallaTxt:tallaTxt,tallaDeVariante:tallaDeVariante,filtraPorTalla:filtraPorTalla,
tallaPerfilGet:tallaPerfilGet,tallaPerfilSetPie:tallaPerfilSetPie,tallaClave:tallaClave,
leadPuede:leadPuede,leadTrasValor:leadTrasValor,leadRedDeSeguridad:leadRedDeSeguridad,askLead:askLead,
maderaEnSoftbol:maderaEnSoftbol,suelaNoSe:suelaNoSe,mapsBtn:mapsBtn,tiendaHtml:tiendaHtml,
recSpikes:recSpikes,recBat:recBat,recGuante:recGuante,recSoftbol:recSoftbol,recKit:recKit,
stepSwap:stepSwap,STEPS:STEPS,PLBL:PLBL,intent:intent,profBase:profBase,renderPool:renderPool,
setLastAll:function(a){lastAll=a},getLastAll:function(){return lastAll},lead:function(){return lead},
setLead:function(v){lead=v}})}
})();
